<template>
  <div>
    <div class="details-panel"  v-loading="isPanelLoading">
        <div class="text-black p-2 pt-5 relative">
          <div
            class="text-xs px-1 font-medium py-0.5 absolute top-0 left-0 right-0 text-center rounded-b-md"
            v-if="eventStatus"
            :class="bgStatusColor(eventStatus)">
            {{eventStatusDisplayName}}
          </div>
          <div class="client-name ml-3 mt-3">{{eventAccount.name}}</div>
          <span class="font-medium text-lg ml-3">{{eventTitle}}</span>
          <div class="sticky flex flex-wrap mb-3 justify-items-stretch justify-between gap-2 px-3">
            <div class="px-4 py-1 bg-RECEIVED hover:bg-yellow-400 text-center grow justify-center text-white cursor-pointer text-[10px] rounded-md flex items-center font-bold"
              @click="setStatus('RECEIVED')" v-if="eventStatusDisplayName === 'CLIENT CONFIRMED' && isSysAdmin">
              RECEIVED
            </div>
            <div class="px-4 py-1 bg-AWAITING_SIGNAL hover:bg-yellow-400 text-center grow justify-center text-white cursor-pointer text-[10px] rounded-md flex items-center font-bold"
              @click="setStatus('AWAITING_SIGNAL')" v-if="(eventStatusDisplayName === 'CLIENT CONFIRMED' || eventStatusDisplayName === 'RECEIVED') && isSysAdmin">
              AWAITING <br> SIGNAL
            </div>
            <div class="px-4 py-1 bg-green-600 hover:bg-green-400 text-center grow justify-center text-white cursor-pointer text-[10px] rounded-md flex items-center uppercase font-bold"
              @click="sysAdminConfirmConfirmation"
              v-if="(eventStatusDisplayName === 'CLIENT CONFIRMED' || eventStatusDisplayName === 'RECEIVED' || eventStatusDisplayName === 'AWAITING SIGNAL') && (isSysAdmin || eventAcl.cfm)">
              MOS <br>Confirm
            </div>
            <!-- <el-button type="warning" size="mini"
              @click.native="setStatus('RECEIVED')" v-if="eventStatusDisplayName === 'CLIENT CONFIRMED' && isSysAdmin">
              RECEIVED
            </el-button>
            <el-button type="warning" size="mini" @click.native="setStatus('AWAITING_SIGNAL')" v-if="(eventStatusDisplayName === 'CLIENT CONFIRMED' || eventStatusDisplayName === 'RECEIVED') && isSysAdmin">
              AWAITING <br> SIGNAL
            </el-button>
            <el-button type="warning" size="mini" @click.native="sysAdminConfirmConfirmation"
              v-if="(eventStatusDisplayName === 'CLIENT CONFIRMED' || eventStatusDisplayName === 'RECEIVED' || eventStatusDisplayName === 'AWAITING SIGNAL') && isSysAdmin">
              MOS <br>Confirm
            </el-button> -->
          </div>
        </div>
        <div id="agenda-event-preview" class="mt-4 sm:mt-0 -ml-2 sm:ml-0">
          <div class="panel-info-message" v-if="!selectedEvent">
            <div>
              <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48"><title>c-info</title><g stroke-linecap="round" stroke-linejoin="round" stroke-width="2" fill="#636e88" stroke="#636e88"><circle data-stroke="none" cx="24" cy="12" r="1" stroke="none"></circle><circle cx="24" cy="24" r="22" fill="none" stroke="#636e88" stroke-miterlimit="10"></circle><circle cx="24" cy="12" r="1" fill="none" stroke-miterlimit="10"></circle><line x1="24" y1="19" x2="24" y2="36" fill="none" stroke-miterlimit="10"></line></g></svg>
              Click or add an event to start
            </div>
            <div class="py-1">
              <div class="flex space-x-2 text-gray-600 text-xs mt-4">
                <div class="px-2 rounded-xs flex-row items-center"><span class="uppercase mr-1 ">Total </span> <span class="text-xl block"> {{eventsStats.total}}</span> </div>
                <div class="px-2 rounded-xs flex-row items-center"><span class="uppercase mr-1 ">Live </span> <span class="text-xl block"> {{eventsStats.live}}</span> </div>
                <div class="px-2 rounded-xs flex-row items-center"><span class="uppercase mr-1 ">Completed </span> <span class="text-xl block"> {{eventsStats.completed}}</span> </div>
                <div class="px-2 rounded-xs flex-row items-center"><span class="uppercase mr-1 ">Remaining </span> <span class="text-xl block"> {{eventsStats.remaining }}</span> </div>
              </div>
            </div>
          </div>
          <div v-bar class="wrapper" v-if="selectedEvent">
            <div>
              <div class="event-preview-content px-5 pb-20" v-if="selectedEvent" >
                <!-- <h4 class="event-title"><strong>{{selectedEvent.name}}</strong></h4>-->
                <el-alert type="warning" :closable="false" v-if="isLive">
                  Service started. Rescheduling disabled.
                </el-alert>
                <el-alert type="warning" :closable="false" v-if="eventStatus === 'PENDING'">
                  This booking needs to be client confirmed
                  <el-button type="warning" size="mini" @click.native="confirmConfirmation">
                    Set Client Confirmed
                  </el-button>
                </el-alert>

                <el-alert type="warning" :closable="false" v-if="eventStatusDisplayName === 'CLIENT CONFIRMED' && !isSysAdmin">
                  This booking is pending resource confirmation by MediaAtmos
                </el-alert>


                <el-alert :closable="false"
                  v-if="eventStatusDisplayName === 'CANCELLED' && selectedEvent.cancellationMsg">
                  {{selectedEvent.cancellationMsg}}
                </el-alert>
                <el-alert type="warning" :closable="false" v-if="selectedEvent.impoortSource">
                  This event has been imported from the
                  <strong>{{selectedEvent.impoortSource | defaultValue('---')}}</strong>.
                  If you proceed and make changes they may be overwritten
                  with the next update from the source.
                </el-alert>
                <el-alert type="warning" :closable="false"
                  v-if="inputDetails.requiresPidInfo && (!selectedEvent.inputAudioPid && !selectedEvent.inputVideoPid)" show-icon>
                  This event requires Audio and Video PID to be set
                </el-alert>
                <el-row :gutter="16">

                  <el-col :span="5">
                    <div class="kicck-off">
                      <div class="label">Line-up</div>
                      <div class="content time-editor"
                        @click="setRescheduleEventDialog(true)"
                        :class="{
                          disableEditing: isPastServiceTime || isLive
                          || !(isAdmin || eventAcl.clientAdmin || eventAcl.eventCoordinator
                          || eventAcl.ee)
                        }">
                        {{selectedEvent.lineupTime | dateUtc}}
                        <ma-edit class="bly-edit"></ma-edit>
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="5">
                    <div class="status">
                      <div class="label">Kick-off</div>
                      <div class="content time-editor"
                        @click="setRescheduleEventDialog(true)"
                        :class="{ disableEditing: isPastServiceTime || isLive
                          || !(isAdmin || eventAcl.clientAdmin || eventAcl.eventCoordinator
                          || eventAcl.ee)
                        }">
                        {{selectedEvent.startTime | dateUtc}}
                        <ma-edit class="bly-edit"></ma-edit>
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="5">
                      <div class="status">
                      <div class="label">End Time</div>
                      <div class="content time-editor"
                        @click="setRescheduleEventDialog(true)"
                        :class="{ disableEditing: isPastServiceTime
                          || isLive
                          || !(isAdmin
                          || eventAcl.clientAdmin
                          || eventAcl.eventCoordinator
                          || eventAcl.ee)}">
                        {{selectedEvent.endTime | dateUtc}}
                        <ma-edit class="bly-edit"></ma-edit>
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="9">
                    <div class="kicck-off">
                      <div class="label">Date</div>
                      <div class="content time-editor"
                        @click="setRescheduleEventDialog(true)"
                        :class="{ disableEditing: isPastServiceTime
                          || isLive
                          || !(isAdmin
                            || eventAcl.clientAdmin
                            || eventAcl.eventCoordinator
                            || eventAcl.ee)}">
                        {{eventDate}}
                        <ma-edit class="bly-edit"></ma-edit>
                      </div>
                    </div>
                  </el-col>
                </el-row>

                <el-row :gutter="16">
                  <el-col :span="12">
                    <div class="label">Service start time</div>
                    <span class="content">
                      {{selectedEvent.serviceStartTime | dateUtc}}
                    </span>
                  </el-col>
                  <el-col :span="12">
                    <div class="label">Service end time</div>
                    <span class="content">
                      {{selectedEvent.serviceEndTime | dateUtc}}
                    </span>
                  </el-col>
                </el-row>
                <br>

                <el-row :gutter="16">
                  <el-col :span="8">
                    <div class="kicck-off"
                      :class="{ disableEditing: isPastServiceTime  }">
                      <el-popover
                        placement="left"
                        width="300"
                        :disabled="!(isAdmin
                          || eventAcl.clientAdmin
                          || eventAcl.eventCoordinator
                          || eventAcl.ee)"
                        @show="edit('fixturePopup', selectedEvent.fixture)"
                        v-model="showPopups.fixturePopup">
                        <p>
                          <el-input type="textarea" size="small" v-model="fixture"></el-input>
                        </p>
                        <div style="text-align: right; margin: 0">
                          <el-button size="mini" type="text"
                            @click="cancel('fixturePopup','fixture')">Cancel</el-button>
                          <el-button type="primary" size="mini"
                            @click="save('fixture', fixture)">Save</el-button>
                        </div>
                        <div class="content editable" slot="reference">
                          <div class="label">Fixture</div>
                          {{selectedEvent.fixture | defaultValue("----")}}
                          <ma-edit class="bly-edit"></ma-edit>
                        </div>
                      </el-popover>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="status"
                      :class="{ disableEditing: isPastServiceTime }">
                      <el-popover
                        placement="left"
                        width="300"
                        :disabled="!(isAdmin || eventAcl.clientAdmin || eventAcl.eventCoordinator
                          || eventAcl.ee)"
                        @show="edit('propertyPopup', selectedEvent.property)"
                        v-model="showPopups.propertyPopup">
                        <p>
                          <el-input type="textarea" size="small" v-model="property"></el-input>
                        </p>
                        <div style="text-align: right; margin: 0">
                          <el-button size="mini" type="text"
                            @click="cancel('propertyPopup','property')">Cancel</el-button>
                          <el-button type="primary" size="mini"
                            @click="save('property', property)">Save</el-button>
                        </div>
                        <div class="content editable" slot="reference">
                          <div class="label">Property</div>
                          {{selectedEvent.property | defaultValue("----")}}
                          <ma-edit class="bly-edit"></ma-edit>
                        </div>
                      </el-popover>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="sport"
                      :class="{ disableEditing: isPastServiceTime }">
                      <el-popover
                        placement="left"
                        width="300"
                        :disabled="!(isAdmin || eventAcl.clientAdmin || eventAcl.eventCoordinator
                          || eventAcl.ee)"
                        @show="edit('sportPopup', selectedEvent.sport)"
                        v-model="showPopups.sportPopup">
                        <p>
                          <el-input type="textarea" size="small" v-model="sport"></el-input>
                        </p>
                        <div style="text-align: right; margin: 0">
                          <el-button size="mini" type="text"
                            @click="cancel('sportPopup','sport')">Cancel</el-button>
                          <el-button type="primary" size="mini"
                            @click="save('sport', sport)">Save</el-button>
                        </div>
                        <div class="content editable" slot="reference">
                      <div class="label">Sport</div>
                          {{selectedEvent.sport | defaultValue("----")}}
                          <ma-edit class="bly-edit"></ma-edit>
                        </div>
                      </el-popover>
                    </div>
                  </el-col>
                </el-row>
                <el-row :gutter="16">
                  <el-col :span="24">
                    <div class="tags" :class="{ disableEditing: isPastServiceTime }">
                       <el-popover
                        placement="left"
                        width="300"
                        :disabled="!(isAdmin || eventAcl.clientAdmin || eventAcl.eventCoordinator || eventAcl.ee)"
                        @show="tags = selectedEvent.tags ? [...selectedEvent.tags] : []; edit('tagsPopup', selectedEvent.tags || [])"
                        v-model="showPopups.tagsPopup">
                        <p>
                          <el-select
                            v-model="tags"
                            multiple
                            filterable
                            allow-create
                            default-first-option
                            placeholder="Tags"
                            style="width: 100%"
                            size="small"
                          >
                          </el-select>
                        </p>
                        <div style="text-align: right; margin: 0">
                           <el-button size="mini" type="text" @click="cancel('tagsPopup')">Cancel</el-button>
                           <el-button type="primary" size="mini" @click="save('tags', tags)">Save</el-button>
                        </div>
                        <div class="content editable" slot="reference">
                           <div class="label">Tags</div>
                           <el-tag
                              v-for="tag in selectedEvent.tags"
                              :key="tag"
                              size="mini"
                              style="margin-right: 5px;"
                           >
                             {{tag}}
                           </el-tag>
                           <span v-if="!selectedEvent.tags || selectedEvent.tags.length === 0">----</span>
                           <ma-edit class="bly-edit"></ma-edit>
                        </div>
                       </el-popover>
                    </div>
                  </el-col>
                </el-row>

                <el-popover
                  placement="left"
                  width="300"
                  :disabled="!(isAdmin || eventAcl.clientAdmin || eventAcl.eventCoordinator
                    || eventAcl.ee)"
                  @show="edit('descriptionPopup', selectedEvent.description)"
                  v-model="showPopups.descriptionPopup">
                  <p>
                    <el-input type="textarea" rows="4" v-model="description"></el-input>
                  </p>
                  <div style="text-align: right; margin: 0">
                    <el-button size="mini" type="text"
                      @click="cancel('descriptionPopup','description')">Cancel</el-button>
                    <el-button type="primary" size="mini"
                      @click="save('description', description)">Save</el-button>
                  </div>
                  <div class="content editable" slot="reference"
                    :class="{ disableEditing: isPastServiceTime }">
                    <div class="label">Description</div>
                    {{selectedEvent.description | defaultValue("----")}}
                    <ma-edit class="bly-edit"></ma-edit>
                  </div>
                </el-popover>

                <el-row :gutter="16" v-if="isSysAdmin">
                  <el-col :span="12">
                    <div class="kicck-off">
                      <el-popover
                        placement="left"
                        width="300"
                        :disabled="!isSysAdmin"
                        @show="edit('inputAudioPid', selectedEvent.inputAudioPid)"
                        v-model="showPopups.inputAudioPidPopup">
                        <p>
                          <el-input type="text" size="small" v-model="inputAudioPid"></el-input>
                        </p>
                        <div style="text-align: right; margin: 0">
                          <el-button size="mini" type="text"
                            @click="cancel('inputAudioPidPopup','inputAudioPid')">Cancel</el-button>
                          <el-button type="primary" size="mini"
                            @click="save('inputAudioPid', inputAudioPid)">Save</el-button>
                        </div>
                        <div class="content editable" slot="reference">
                          <div class="label">Input Audio Pid </div>
                          {{selectedEvent.inputAudioPid | defaultValue("----")}}
                          <ma-edit class="bly-edit"></ma-edit>
                        </div>
                      </el-popover>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div class="kicck-off">
                      <el-popover
                        placement="left"
                        width="300"
                        :disabled="!isSysAdmin"
                        @show="edit('inputVideoPid', selectedEvent.inputVideoPid)"
                        v-model="showPopups.inputVideoPidPopup">
                        <p>
                          <el-input type="text" size="small" v-model="inputVideoPid"></el-input>
                        </p>
                        <div style="text-align: right; margin: 0">
                          <el-button size="mini" type="text"
                            @click="cancel('inputVideoPidPopup','inputVideoPid')">Cancel</el-button>
                          <el-button type="primary" size="mini"
                            @click="save('inputVideoPid', inputVideoPid)">Save</el-button>
                        </div>
                        <div class="content editable" slot="reference">
                          <div class="label">Input Video Pid </div>
                          {{selectedEvent.inputVideoPid | defaultValue("----")}}
                          <ma-edit class="bly-edit"></ma-edit>
                        </div>
                      </el-popover>
                    </div>
                  </el-col>
                </el-row>

                <!-- -------------------------------------------------------------------------- -->
                <!-- AUDIO -------------------------------------------------------------------- -->
                <!-- -------------------------------------------------------------------------- -->
                <div class="label">Source Audio</div>
                <div class="content">
                  <div class="preview-panel-audio-channel min-h-[32px]"
                    v-for="(audioChannel, index) in sortedAudioMapping"
                    :key="audioChannel.description + index + audioChannel.channelNo + 'audio'">
                    <div class="preview-panel-audio-channel-number">
                      {{audioChannel.channelNo}}
                        <el-tooltip content="Active" placement="left"  v-show="audioChannel.active">
                          <div class="audio-is-active"
                        ></div>
                        </el-tooltip>
                      </div>
                    <div class="preview-panel-audio-channel-name-left">
                      {{audioChannel.description !== ' ' ?  audioChannel.description : '---'}} &nbsp;
                    </div>
                    <div class="preview-panel-audio-channel-stereo">
                      <el-tag size="mini" type="danger" v-show="audioChannel.stereo || audioChannel.stereo === null">STEREO</el-tag>
                      <el-tag size="mini" type="info" v-show="!audioChannel.stereo && audioChannel.stereo !== null">MONO</el-tag>
                    </div>
                    <div class="preview-panel-audio-channel-actions">

                      <!---------------------------
                        AUDIO CHANNEL EDIT POPUOVER
                      ------------------------------->
                      <el-popover
                        placement="left"
                        @show="editAudioChannel(audioChannel, index)"
                        @hide="clearAudioPopup"
                        width="400"
                        :visible-arrow="false"
                        :popper-options="{boundariesElement: '.content'}"
                        v-model="audoMappingPopups[index]">
                        <el-form ref="editAudioForm" label-position="left"
                          :model="tempAudioMapping">
                          <p>
                            <el-form-item label="Pair #" prop="channelNo">
                              <el-input size="mini"
                                v-model="tempAudioMapping.channelNo" placeholder="#">
                              </el-input>
                            </el-form-item>
                            <el-form-item label="Description" prop="description">
                              <el-input size="mini"
                                v-model="tempAudioMapping.description" placeholder="Description">
                              </el-input>
                            </el-form-item>
                            <el-form-item>
                              <el-switch v-model="tempAudioMapping.active"
                                active-text="Active">
                              </el-switch>
                            </el-form-item>
                            <el-form-item>
                              <el-radio-group v-model="tempAudioMapping.stereo" size="mini">
                                <el-radio-button :label="true">STEREO</el-radio-button>
                                <el-radio-button :label="false">MONO</el-radio-button>
                              </el-radio-group>
                            </el-form-item>
                          </p>
                          <div style="text-align: right; margin: 0">
                            <el-button size="mini" type="text"
                              @click="cancelAudioEdit(index)">Cancel</el-button>
                            <el-button type="primary" size="mini"
                              @click="saveAudioMapping(index)">Save</el-button>
                          </div>
                        </el-form>

                        <span class="" slot="reference">
                          <el-tooltip content="Edit audio channel"
                            slot="reference"
                            v-if="isAdmin || eventAcl.clientAdmin || eventAcl.eventCoordinator
                              || eventAcl.ee"
                            v-show="!isLive">
                            <ma-edit class="bly-edit btn-icon"></ma-edit>
                          </el-tooltip>
                        </span>
                      </el-popover>
                      <!---------------------------
                        // AUDIO CHANNEL EDIT POPUOVER
                      ------------------------------->
                      <el-tooltip content="Delete audio channel">
                        <ma-delete class="bly-delete btn-icon"
                        v-if="isAdmin || eventAcl.clientAdmin || eventAcl.eventCoordinator
                          || eventAcl.ee"
                        v-show="!isLive"
                        @click="deleteAudioChannel(audioChannel.id,
                        selectedEvent)"></ma-delete>
                      </el-tooltip>
                    </div>
                  </div>
                  <el-button size="mini" type="primary"
                    v-show="isAdmin || eventAcl.clientAdmin || eventAcl.eventCoordinator
                      || eventAcl.ee"
                    v-if="!isLive"
                    @click="showAudioMappingEditForm = !showAudioMappingEditForm">
                    Add audio pair
                  </el-button>
                  <br>
                  <br>
                  <el-card shadow="never" v-show="showAudioMappingEditForm">
                    <div class="audio-mapping-form">
                      <el-form ref="eventNewAudioMappingForm" label-position="left"
                        :model="audioMappingForm">
                            <el-form-item label="Pair #" prop="channelNo">
                              <el-input size="mini"
                                v-model="audioMappingForm.channelNo" placeholder="#">
                              </el-input>
                            </el-form-item>
                            <el-form-item label="Description" prop="description">
                              <el-input size="mini"
                                v-model="audioMappingForm.description" placeholder="Description">
                              </el-input>
                            </el-form-item>
                            <el-form-item label="Active">
                              <el-switch v-model="audioMappingForm.active" class="mt-1"></el-switch>
                            </el-form-item>
                            <el-form-item label="Stereo" style="text-align:right">
                              <el-radio-group v-model="audioMappingForm.stereo" size="mini">
                                <el-radio-button :label="true">STEREO</el-radio-button>
                                <el-radio-button :label="false">MONO</el-radio-button>
                              </el-radio-group>
                            </el-form-item>
                        <el-button size="small"
                          class="mr-1"
                          @click="showAudioMappingEditForm = !showAudioMappingEditForm">Cancel
                        </el-button>
                        <el-button
                          size="small"
                          type="primary"
                          @click="addAudioChannel
                          ('eventNewAudioMappingForm', selectedEvent.audioMapping.items,
                            selectedEvent)">
                          Add audio pair
                        </el-button>
                      </el-form>
                    </div>
                  </el-card>
                </div>

                <div class="label">Extend booking time</div>
                <div class="content">
                  <el-card shadow="hover" :body-style="{padding: '8px'}" v-if="false">
                    <el-row :gutter="16">
                      <el-col :span="4">Head: </el-col>
                      <el-col :span="17">{{selectedEvent.headTimeMin | defaultValue(0)}} min
                      </el-col>
                      <el-col :span="3" v-show="!isPastServiceTime && isBeforeServiceTimeStart">
                        <el-dropdown trigger="click"
                          v-show="isAdmin || eventAcl.clientAdmin || eventAcl.eventCoordinator
                            || eventAcl.ee">
                          <ma-more class="bly-more bi-rotate-90"></ma-more>
                          <el-dropdown-menu slot="dropdown">

                            <el-dropdown-item icon="bi bly-minus"
                              @click.native="addTime(selectedEvent, 'head', 30)">
                                30<span>min</span> </el-dropdown-item>
                            <el-dropdown-item icon="bi bly-minus"
                              @click.native="addTime(selectedEvent, 'head', 60)">
                                60<span>min</span> </el-dropdown-item>
                            <el-dropdown-item icon="bi bly-minus"
                              @click.native="addTime(selectedEvent, 'head', 90)">
                              90<span>min</span> </el-dropdown-item>
                            <el-dropdown-item icon="bi bly-minus"
                              @click.native="addTime(selectedEvent, 'head', 120)">
                              120<span>min</span> </el-dropdown-item>
                            <el-dropdown-item icon="bi bly-minus"
                              @click.native="openAddTime(selectedEvent, 'head')">
                                Custom </el-dropdown-item>

                          </el-dropdown-menu>
                        </el-dropdown>
                      </el-col>
                    </el-row>
                  </el-card>
                  <br>
                  <el-card shadow="hover" :body-style="{padding: '8px'}">
                    <el-row :gutter="16">
                      <el-col :span="8">Time added: </el-col>
                      <el-col :span="13">{{selectedEvent.tailTimeMin | defaultValue(0)}} min
                      </el-col>
                      <el-col :span="3" class="text-right" v-show="!isPastServiceTime">
                        <el-dropdown trigger="click"
                          v-show="isAdmin || eventAcl.clientAdmin || eventAcl.eventCoordinator
                            || eventAcl.ee || eventAcl.eo">
                          <ma-more class="bly-more bi-rotate-90"></ma-more>
                          <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item icon="bi bly-minus"
                              @click.native="addTime(selectedEvent, 'tail', 30)">
                                30<span>min</span> </el-dropdown-item>
                            <el-dropdown-item icon="bi bly-minus"
                              @click.native="addTime(selectedEvent, 'tail', 60)">
                                60<span>min</span> </el-dropdown-item>
                            <el-dropdown-item icon="bi bly-minus"
                              @click.native="addTime(selectedEvent, 'tail', 90)">
                              90<span>min</span> </el-dropdown-item>
                            <el-dropdown-item icon="bi bly-minus"
                              @click.native="addTime(selectedEvent, 'tail', 120)">
                              120<span>min</span> </el-dropdown-item>
                            <el-dropdown-item icon="bi bly-minus"
                              @click.native="openAddTime(selectedEvent, 'tail')">
                                Custom </el-dropdown-item>
                            <el-dropdown-item divided icon="bi bly-minus"
                              @click.native="addTime(selectedEvent, 'tail', -30)">
                                -30<span>min</span> </el-dropdown-item>
                            <el-dropdown-item icon="bi bly-minus"
                              @click.native="addTime(selectedEvent, 'tail', -60)">
                                -60<span>min</span> </el-dropdown-item>
                            <el-dropdown-item icon="bi bly-minus"
                              @click.native="addTime(selectedEvent, 'tail', -90)">
                              -90<span>min</span> </el-dropdown-item>
                            <el-dropdown-item icon="bi bly-minus"
                              @click.native="addTime(selectedEvent, 'tail', -120)">
                              -120<span>min</span> </el-dropdown-item>
                            <el-dropdown-item icon="bi bly-minus"
                              @click.native="openAddTime(selectedEvent, 'tail', 'remove')">
                                Custom remove </el-dropdown-item>
                          </el-dropdown-menu>
                        </el-dropdown>
                      </el-col>
                    </el-row>
                  </el-card>
                </div>

                <!-- -------------------------------------------------------------------------- -->
                <!-- INPUTS SECTION ----------------------------------------------------------- -->
                <!-- -------------------------------------------------------------------------- -->

                <el-row :gutter="16">
                  <el-col :span="24">
                    <div class="label">Input</div>
                    <div class="content donwling-config-information"
                      :class="{
                        disableEditing: isPastServiceTime
                        || !(isAdmin || eventAcl.clientAdmin
                          || eventAcl.eventCoordinator || eventAcl.ee)
                        || hardDisableEdit
                      }">
                      <el-popover
                        placement="right"
                        width="250"
                        v-model="showPopups.inputPopup"
                        :disabled="!(isAdmin || eventAcl.clientAdmin || eventAcl.eventCoordinator
                          || eventAcl.ee)"
                        trigger="click">
                        <div v-bar class="dd-popup-wrapper h-300">
                          <div>
                            <div v-if="accountInputProfiles.length" class="px-3 py-1 text-xs uppercase opacity-50">Input profiles</div>
                            <el-dropdown-item
                                v-for="profile in accountInputProfiles"
                                :key="profile.id"
                                @click.native="changeInputProfile(profile)"
                                :title="profile.name"
                                >
                                <span>{{profile.name | truncate(23)}}</span>
                                <small style="opacity: 0.6; float: right; margin-left: 10px">PROFILE</small>
                            </el-dropdown-item>
                            <div class="px-3 py-1 text-xs uppercase opacity-50">Inputs</div>
                            <el-dropdown-item
                                v-for="input in accountInputs"
                                :key="input.id"
                                @click.native="changeInput(input)"
                                :title="input.name + ' ' + input.status"
                                >
                                <span v-if="input.name">{{input.name | truncate(23)}}</span>

                            </el-dropdown-item>
                          </div>
                        </div>
                        <span class="el-dropdown-link" slot="reference">
                          {{inputName}} {{inputStatus(selectedEvent)}}
                          <span class="output-type-tag" v-if="selectedInputProfile">PROFILE</span>
                          <span class="output-type-tag" v-if="inputProfileOverride">CONFIG OVERRIDE</span>
                          <i class="el-icon-arrow-down el-icon--right"
                            v-show="!isPastServiceTime"></i>
                        </span>
                      </el-popover>
                      <el-popover
                        placement="left"
                        width="300"
                        :disabled="!(isSysAdmin || eventAcl.clientAdmin || eventAcl.eventCoordinator
                          || eventAcl.ee)"
                        @show="inputInfo = selectedEvent.inputDetails; edit('inputDetails', selectedEvent.inputDetails)"
                        v-model="showPopups.inputDetailsPopup">
                        <p>
                          <el-input type="text" size="small" v-model="inputInfo"></el-input>
                        </p>
                        <div style="text-align: right; margin: 0">
                          <el-button size="mini" type="text"
                            @click="cancel('inputDetailsPopup','inputInfo')">Cancel</el-button>
                          <el-button type="primary" size="mini"
                            @click="save('inputDetails', inputInfo)">Save</el-button>
                        </div>
                        <div class="content editable" slot="reference">
                          <div class="label mt-4" v-show="hasInputDetailsEnabled">Input Details </div>

                          <div class="muted"  v-show="hasInputDetailsEnabled">{{selectedEvent.inputDetails || '-----'}}</div>
                          <ma-edit class="bly-edit"></ma-edit>
                        </div>
                      </el-popover>
                      <!-- <div class="muted">{{selectedEvent.inputDetails || '-----'}}</div> -->
                      <div class="extended" v-if="selectedInputProfile">
                        <div class="label mt-4">Input profile</div>
                        <div class="muted">{{selectedInputProfile.description || '-----'}}</div>
                        <div v-if="selectedInputProfile.provider">
                          <div class="label mt-4">Provider</div>
                          <div><strong>{{selectedInputProfile.provider.name}}</strong></div>
                          <div class="muted" v-if="selectedInputProfile.provider.contactDetails">
                            {{selectedInputProfile.provider.contactDetails}}
                          </div>
                          <div class="muted whitespace-pre-line" v-if="selectedInputProfile.provider.instructions">
                            {{selectedInputProfile.provider.instructions}}
                          </div>
                        </div>
                      </div>
                      <div class="extended" v-if="inputDetails.type === 'DOWNLINK'">
                        <br>
                        <div class="label">Downlink Config
                          <el-tooltip content="Copy downlink config information">
                            <i
                              @click="copyToClipboard('downlinkInfo')"
                              class="bi bly-clipbin icon-btn copy-all ma-btn">

                            </i>
                          </el-tooltip>
                        </div>
                        <div class="warning" v-if="!downLinkConfig">
                          <ma-warning class="bly-warning"></ma-warning>
                          Downlink config is missing
                        </div>
                        <el-popover
                          placement="left"
                          width="300"
                          :disabled="!(isAdmin || eventAcl.clientAdmin || eventAcl.eventCoordinator
                            || eventAcl.ee)"
                          @show="edit('downlinkConfigPopup', selectedEvent.description)"
                          v-model="showPopups.downlinkConfigPopup">
                          <div>
                            <div v-if="downlinkConfigForm">
                              Name & pos <span class="text-red-500">*</span><br>
                              <el-input v-model="downlinkConfigForm.satelliteName" class="mb-1" required></el-input>
                              BISS <span class="text-red-500">*</span><br>
                              <el-input v-model="downlinkConfigForm.BISS" class="mb-1" required></el-input>
                              Service ID <span class="text-red-500">*</span><br>
                              <el-input v-model="downlinkConfigForm.service" class="mb-1" required></el-input>
                              Polarization <span class="text-red-500">*</span><br>
                              <el-radio-group v-model="downlinkConfigForm.satellitePolarization"
                                size="small" class="mb-1"
                                 required>
                                <el-radio-button label="Vertical">Vertical</el-radio-button>
                                <el-radio-button label="Horizontal">Horizontal</el-radio-button>
                              </el-radio-group>
                              Frequency <br>
                              <el-input-number v-model="downlinkConfigForm.satelliteFrequency" class="mb-1">
                              </el-input-number> <br>
                              Symbol Rate <br>
                              <el-input
                                placeholder="Choose or enter rate"
                                v-model="downlinkConfigForm.symbolRate">
                                <el-dropdown slot="append" size="small" type="primary">
                                  <el-button type="primary">
                                    <i class="el-icon-arrow-down el-icon--right"></i>
                                  </el-button>
                                  <el-dropdown-menu slot="dropdown">
                                  <el-dropdown-item
                                    v-for="item in [3400,3600,5000,7000,7120,7200,7500,9850,10000,12500,15000,34000]"
                                    :key="item"
                                    @click.native="downlinkConfigForm.symbolRate = item"
                                    >{{item}}</el-dropdown-item>
                                  </el-dropdown-menu>
                                </el-dropdown>
                              </el-input>
                            </div>
                          </div>
                          <div style="text-align: right; margin: 0">
                            <el-button size="mini" type="text"
                              @click="cancel('downlinkConfigPopup','downlink')">Cancel</el-button>
                            <el-button type="primary" size="mini"
                              :disabled="!downlinkConfigForm.satelliteName || !downlinkConfigForm.BISS || !downlinkConfigForm.service || !downlinkConfigForm.satellitePolarization"
                              @click="updateDownlinkConfig()">Save</el-button>
                          </div>
                          <div class="content editable" slot="reference"
                            :class="{ disableEditing: isPastServiceTime }">

                              <div v-if="!downLinkConfig">
                                <div class="el-button el-button--primary el-button--mini">Update config</div>
                              </div>
                              <div v-if="downLinkConfig" id="downlinkInfo">
                                <div>
                                  <span>Name & pos:
                                  <strong id="downlinkInfo-name">{{downLinkConfig.satelliteName}}</strong></span>
                                  <ma-clipbin @click="copyToClipboard('downlinkInfo-name')"
                                    class="bly-clipbin copy-property"></ma-clipbin>
                                </div>
                                <div>
                                  <span>
                                    Frequency:
                                    <strong id="downlinkInfo-satelliteFrequency">{{downLinkConfig.satelliteFrequency}}</strong>
                                    <ma-clipbin @click="copyToClipboard('downlinkInfo-satelliteFrequency')"
                                      class="bly-clipbin copy-property"></ma-clipbin>
                                  </span>
                                </div>
                                <div>
                                  <span>Polarization:
                                    <strong id="downlinkInfo-satellitePolarization">{{downLinkConfig.satellitePolarization}}</strong>
                                    <ma-clipbin @click="copyToClipboard('downlinkInfo-satellitePolarization')"
                                    class="bly-clipbin copy-property"></ma-clipbin>
                                  </span>
                                </div>
                                <div>
                                  <span>
                                    BISS:
                                    <strong id="downlinkInfo-BISSx">
                                      {{downLinkConfig.BISS}}
                                    </strong>
                                    <strong id="downlinkInfo-BISS" class="hide" style="opacity:0; position: absolute">
                                      {{downLinkConfig.BISS | removeSpaces(false)}}
                                    </strong>
                                    <ma-clipbin @click="copyToClipboard('downlinkInfo-BISS')"
                                    class="bly-clipbin copy-property"></ma-clipbin>
                                  </span>
                                </div>
                                <div>
                                  <span>
                                    Symbol Rate:
                                    <strong id="downlinkInfo-symbolRate">
                                      {{downLinkConfig.symbolRate | defaultValue('----')}}
                                    </strong>
                                    <ma-clipbin @click="copyToClipboard('downlinkInfo-symbolRate')"
                                    class="bly-clipbin copy-property"></ma-clipbin>
                                  </span>
                                </div>
                                <div>
                                  <span>
                                    Service ID:
                                    <strong id="downlinkInfo-service">
                                      {{downLinkConfig.service | defaultValue('----')}}
                                    </strong>
                                    <ma-clipbin @click="copyToClipboard('downlinkInfo-service')"
                                    class="bly-clipbin copy-property"></ma-clipbin>
                                  </span>
                                </div>
                              </div>
                            <ma-edit class="bly-edit"></ma-edit>
                          </div>
                        </el-popover>
                      </div>
                      <div v-if="inputDetails.frcAvailable" class="mt-2">
                        <el-switch v-model="selectedEvent.inputFrcEnabled" @change="toggleFRC('inputFrcEnabled', selectedEvent.inputFrcEnabled)"  active-text="Enable Framerate conversion"
                        >
                        </el-switch>

                        <div v-if="selectedEvent.inputFrcEnabled" class="mt-3">
                          <el-card shadow="hover" style="margin-bottom: 8px" :body-style="{ padding: '8px' }" >
                              Input format:
                            <span class="text-right" style="float:right">
                              <el-dropdown
                                v-show="isAdmin || eventAcl.clientAdmin || eventAcl.eventCoordinator || eventAcl.ee || eventAcl.eo">
                                <strong class="el-dropdown-link">{{selectedEvent.inputFrcInputFormat ? selectedEvent.inputFrcInputFormat.name : 'Select Format'}}</strong>
                                <el-dropdown-menu slot="dropdown">
                                  <el-dropdown-item
                                    v-for="format in pictureFormats" :key="format.id"
                                    @click.native="save('eventInputFrcInputFormatId', format.id)">
                                    {{format.name}}
                                  </el-dropdown-item>
                                </el-dropdown-menu>
                              </el-dropdown>
                            </span>
                          </el-card>
                          <el-card shadow="hover" style="margin-bottom: 8px" :body-style="{ padding: '8px' }" >
                              Output format:
                              <span class="text-right" style="float:right">
                                <el-dropdown
                                  v-show="isAdmin || eventAcl.clientAdmin || eventAcl.eventCoordinator || eventAcl.ee || eventAcl.eo">
                                  <strong class="el-dropdown-link">{{selectedEvent.inputFrcOututFormat ? selectedEvent.inputFrcOututFormat.name : 'Select Format'}}</strong>
                                  <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item
                                      v-for="format in pictureFormats" :key="format.id"
                                      @click.native="save('eventInputFrcOututFormatId', format.id)">
                                      {{format.name}}
                                    </el-dropdown-item>
                                  </el-dropdown-menu>
                                </el-dropdown>
                              </span>
                          </el-card>
                        </div>
                      </div>
                    </div>
                  </el-col>
                </el-row>


                <el-row  v-if="isSysAdmin">
                  <div class="sys-admin-menu">
                    <div class="label">
                      Input override
                    </div>
                    <div class="content">
                      <el-popover
                        placement="right"
                        width="250"
                        v-model="showPopups.ovrrideInputPopup"
                        trigger="click">
                        <div v-bar class="dd-popup-wrapper h-300">
                          <div>
                            <div>
                              <input v-model="searchInputOverride" type="text" placeholder="Search input"
                                class="border m-1 w-full p-1 rounded-sm"
                                >
                            </div>
                            <!-- inputs only - there is no profile override field in the API -->
                            <el-dropdown-item
                                v-for="input in allInputsFiltered"
                                :key="input.id"
                                @click.native="ovrrideInput(input)"
                                :title="input.name + ' ' + inputStatus(input)"
                                >
                                <span v-if="input.name">{{input.name | truncate(23)}}</span>
                                {{inputStatus(input)}}</el-dropdown-item>
                          </div>
                        </div>
                        <span class="el-dropdown-link" slot="reference">
                          {{overrideInputName}}
                          <i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                      </el-popover>
                    </div>
                    <!-- the override only overlays a profile, so it is pointless without one -->
                    <div class="label" v-if="selectedInputProfile">
                      Input profile config override
                    </div>
                    <div class="content" v-if="selectedInputProfile">
                      <div v-if="inputProfileOverrideDraft === null">
                        <span class="muted">{{inputProfileOverrideSummary}}</span>
                        <el-button size="mini" type="text" @click="editInputProfileOverride">
                          {{inputProfileOverride ? 'Edit' : 'Add'}}
                        </el-button>
                        <el-button v-if="inputProfileOverride" size="mini" type="text"
                          @click="clearInputProfileOverride">Remove</el-button>
                      </div>
                      <div v-else>
                        <bly-input-profile-config-editor
                          :value="inputProfileOverrideDraft"
                          @input="inputProfileOverrideDraft = $event">
                        </bly-input-profile-config-editor>
                        <div style="text-align: right" class="mt-2">
                          <el-button size="mini" type="text"
                            @click="inputProfileOverrideDraft = null">Cancel</el-button>
                          <el-button size="mini" type="primary"
                            @click="saveInputProfileOverride">Save</el-button>
                        </div>
                      </div>
                    </div>
                    <!-- Reconfigures the running ingest, unlike the edits above which only
                         change the booking. -->
                    <div class="label">
                      Live input
                    </div>
                    <div class="content">
                      <span class="muted">Push another profile or this booking's config to the running ingest</span>
                      <el-button size="mini" type="text" @click="liveInputUpdateVisible = true">
                        Update input live
                      </el-button>
                    </div>
                  </div>
                </el-row>

                <div class="label">
                  Outputs
                </div>
                <div class="content preview-outputs">
                  <el-card shadow="hover" :body-style="{ padding: '8px' }"
                    class="input"
                    v-for="(target, index) in sortedActions"
                    :key="target + 'x' + index">
                    <div v-if="target.actionType === 'ROUTE'" :class="`output-${target.assignedOutput.status}`">
                      <div>
                        {{target.assignedOutput.displayName || target.assignedOutput.name}}
                        <span class="output-status-tag" v-show="target.assignedOutput.status === 'DELETED'">
                          {{target.assignedOutput.status}}
                        </span>
                        <span class="output-type-tag" :class="getDisplayOutputType(target.assignedOutput)">
                          {{getDisplayOutputType(target.assignedOutput)}}
                        </span>
                        <span class="output-type-tag ROUTE">
                          ROUTE
                        </span>
                        <!-- Router Status Indicator -->
                        <span
                          class="router-output-status relative -top-[3px] ml-1 py-1"
                          :class="getRouterStatusClass(target.assignedOutput.id, target.assignedOutput.outputType)"
                          :title="`Router Status: ${getReadableRouterStatus(target.assignedOutput.id, target.assignedOutput.outputType)}`"
                        >
                          <span class="router-status-dot" :class="getRouterStatusClass(target.assignedOutput.id, target.assignedOutput.outputType)"></span>
                          {{getReadableRouterStatus(target.assignedOutput.id, target.assignedOutput.outputType)}}
                        </span>
                        <br>
                      </div>

                      <div class="actions">
                        <el-tooltip content="Connection Info">
                            <small class="mt-1" @click="selectedOutput = {output: target.assignedOutput, target: null}; outputReportDialog = true;">
                                <ma-info class="el-tooltip bly-info icon-btn ma-btn" />
                            </small>
                          </el-tooltip>
                        <el-tooltip content="Edit Stream Router" v-if="isAdmin || eventAcl.clientAdmin || eventAcl.eventCoordinator || eventAcl.ee">
                            <small class="mt-1" @click="openStreamRouterEdit(target)">
                                <i class="el-tooltip bi bly-pencil icon-btn ma-btn" />
                            </small>
                        </el-tooltip>
                      </div>
                    </div>
                    <div v-if="target.actionType !== 'ROUTE'">
                      <span class="target" v-if="target.configWowza.targets.items[0]" :class="`output-${target.assignedOutput.status}`">
                        <el-tooltip
                          :content="'Autostart enabled: (' + target.configWowza.autostartOffsetMin + 'min)'"
                          v-show="target.configWowza.autostart">
                          <span><ma-time class="bly-time" /></span>
                        </el-tooltip>
                        {{target.assignedOutput.displayName || target.configWowza.targets.items[0].target}}
                        <span class="output-type-tag" :class="getDisplayOutputType(target.assignedOutput)">
                          {{getDisplayOutputType(target.assignedOutput)}}
                        </span>
                        <span class="output-status-tag" v-show="target.assignedOutput.status === 'DELETED'">
                          {{target.assignedOutput.status}}
                        </span>
                        <!-- Router Status Indicator -->
                        <span
                          class="router-output-status relative -top-[3px] ml-1 py-1"
                          :class="getRouterStatusClass(target.assignedOutput.id, target.assignedOutput.outputType)"
                          :title="`Router Status: ${getReadableRouterStatus(target.assignedOutput.id, target.assignedOutput.outputType)}`"
                        >
                          <span class="router-status-dot" :class="getRouterStatusClass(target.assignedOutput.id, target.assignedOutput.outputType)"></span>
                          {{getReadableRouterStatus(target.assignedOutput.id, target.assignedOutput.outputType)}}
                        </span>
                        {{target.actionOutputMap.outputOttApplicationOverride}}
                      </span>
                      <br>
                      <small class="stream-key">
                        <i class="far fa-key" /> {{target.configWowza.targets.items[0].streamKey
                          | defaultValue('--- not set ---')}}
                      </small>
                      <small class="transcoder-profile" v-if="target.configWowza.targets.items[0].transcoderProfile">
                        <i class="far fa-random" />{{target.configWowza.targets.items[0].transcoderProfile
                          | defaultValue('--- not set ---')}}
                      </small>
                      <small class="stream-key" v-if="target.actionOutputMap.outputOttApplicationOverride">
                        (OTT Override: {{target.actionOutputMap.outputOttApplicationOverride}})
                      </small>
                      <div class="actions" v-show="!isPastServiceTime || !hardDisableEdit">
                        <el-tooltip content="Connection Info">
                          <small class="mt-1" @click="selectedOutput = {output: target.assignedOutput, target: target.configWowza.targets.items[0]}; outputReportDialog = true">
                              <ma-info class="el-tooltip bly-info icon-btn ma-btn" />
                          </small>
                        </el-tooltip>
                        <el-tooltip content="Start stream">
                          <ma-play v-show="isAdmin || eventAcl.clientAdmin || eventAcl.eo || eventAcl.ec"
                            @click="startStream(
                              target.configWowza.targets.items[0], selectedEvent
                            )"
                            class="bly-play icon-btn ma-btn" />
                        </el-tooltip>
                        <el-tooltip content="Stop stream">
                          <ma-stop v-show="isAdmin || eventAcl.clientAdmin || eventAcl.eo || eventAcl.ec"
                            @click="stopStream(
                              target.configWowza.targets.items[0], selectedEvent
                            )"
                            class="bly-stop icon-btn ma-btn" />
                        </el-tooltip>
                        <el-tooltip content="Edit Wowza Stream" v-if="isAdmin || eventAcl.clientAdmin || eventAcl.eventCoordinator || eventAcl.ee">
                            <small class="mt-1" @click="openWowzaEdit(target)">
                                <i class="el-tooltip bi bly-pencil icon-btn ma-btn" />
                            </small>
                        </el-tooltip>

                        <el-tooltip content="Set stream key">
                          <ma-edit v-show="isAdmin || eventAcl.clientAdmin || eventAcl.eventCoordinator || eventAcl.ee || eventAcl.eo"
                            :disabled="isPastServiceTime
                              || target.configWowza.targets.items[0].noStremKeyRequired"
                            @click="editStreamKey(target)"
                            class="bly-edit icon-btn ma-btn" />
                        </el-tooltip>

                        <el-tooltip content="Set transcoding channel">
                          <i
                            v-show="isAdmin || eventAcl.clientAdmin || eventAcl.eventCoordinator || eventAcl.ee || eventAcl.eo"
                            :disabled="isPastServiceTime"
                            @click="editTranscoderProfile(target)"
                            class="far fa-random icon-btn ma-btn" />
                        </el-tooltip>

                        <el-tooltip content="Override OTT Application">
                          <i class="icon-btn ma-btn"
                            v-show="isSysAdmin"
                            @click="editOutputOverride(target)">
                            <font-awesome-icon icon="exchange-alt"/>
                          </i>
                        </el-tooltip>
                        <el-tooltip content="Set autostart time">
                          <ma-time v-show="isAdmin || eventAcl.clientAdmin || eventAcl.eventCoordinator || eventAcl.ee || eventAcl.eo"
                            :disabled="isPastServiceTime
                              || target.configWowza.targets.items[0].noStremKeyRequired"
                            @click="setAutostart(target)"
                            class="bly-time icon-btn ma-btn"
                            :class="{active: target.configWowza.autostart}" />
                        </el-tooltip>
                        <!-- <el-tooltip content="more">
                          <el-dropdown trigger="click"
                            v-if="false"
                            v-show="isAdmin || eventAcl.clientAdmin || eventAcl.eo">
                            <ma-more class="bly-more icon-btn bi-rotate-90 ma-btn"></ma-more>
                            <el-dropdown-menu slot="dropdown">
                              <el-dropdown-item icon="bi bly-edit"
                                :disabled="isPastServiceTime
                                  || target.configWowza.targets.items[0].noStremKeyRequired"
                                @click.native="editStreamKey(target)">
                                Edit stream key
                              </el-dropdown-item>
                              <el-dropdown-item icon="bi bly-delete"
                                v-if="false"
                                v-show="isAdmin || eventAcl.clientAdmin || eventAcl.eventCoordinator
                                  || eventAcl.ee"
                                @click.native="deleteOutput(target.assignedOutput)">
                                Delete output
                              </el-dropdown-item>
                            </el-dropdown-menu>
                          </el-dropdown>
                        </el-tooltip> -->
                      </div>
                    </div>
                  </el-card>

                  <el-card shadow="hover" :body-style="{ padding: '8px' }"
                    class="input"
                    v-for="(target, index) in transcodeActions"
                    :key="'transcode-' + index">
                    <div :class="`output-${target.assignedOutput.status}`">
                      <div>
                        {{target.assignedOutput.displayName || target.assignedOutput.name}}
                        <span class="output-status-tag" v-show="target.assignedOutput.status === 'DELETED'">
                          {{target.assignedOutput.status}}
                        </span>
                        <span class="output-type-tag" :class="getDisplayOutputType(target.assignedOutput)">
                          {{getDisplayOutputType(target.assignedOutput)}}
                        </span>
                        <span class="output-type-tag TRANSCODE">
                          TRANSCODE
                        </span>
                        <!-- Router Status Indicator -->
                        <span
                          class="router-output-status relative -top-[3px] ml-1 py-1"
                          v-if="eventStatus === 'LIVE'"
                          :class="getRouterStatusClass(target.assignedOutput.id, target.assignedOutput.outputType)"
                          :title="`Router Status: ${getReadableRouterStatus(target.assignedOutput.id, target.assignedOutput.outputType)}`"
                        >
                          <span class="router-status-dot" :class="getRouterStatusClass(target.assignedOutput.id, target.assignedOutput.outputType)"></span>
                          {{getReadableRouterStatus(target.assignedOutput.id, target.assignedOutput.outputType)}}
                        </span>
                        <br>
                      </div>

                      <div class="mt-2 pl-2 border-l-2 border-orange-500/30">
                        <div v-if="target.transcodingProfile">
                          <small class="text-gray-400 font-semibold uppercase text-[10px] block mb-0.5">Transcoding Channel</small>
                          <small><strong>{{target.transcodingProfile.name}}</strong></small>
                        </div>
                        <div v-if="target.transcodingOutputs && target.transcodingOutputs.items.length" class="mt-1">
                          <small class="text-gray-400 font-semibold uppercase text-[10px] block mb-0.5">Transcoding Outputs</small>
                          <el-tag
                            v-for="item in target.transcodingOutputs.items"
                            :key="item.transcodingOutput.id"
                            size="mini"
                            class="mr-1 mb-1"
                          >
                            {{item.transcodingOutput.name}}
                          </el-tag>
                        </div>
                        <div v-if="transcodeDestinationUrls(target).length" class="mt-1">
                          <small class="text-gray-400 font-semibold uppercase text-[10px] block mb-0.5">Playback (HLS)</small>
                          <div
                            v-for="(url, urlIndex) in transcodeDestinationUrls(target)"
                            :key="url"
                            class="flex items-center gap-1">
                            <a
                              class="text-xs underline cursor-pointer"
                              @click.prevent="openHlsPlayer(url, target.assignedOutput.displayName || target.assignedOutput.name)">
                              Play{{ transcodeDestinationUrls(target).length > 1 ? ` ${urlIndex + 1}` : '' }}
                            </a>
                            <el-tooltip content="Copy HLS URL">
                              <ma-clipbin class="bly-clipbin copy-property" @click="copyValue(url)"></ma-clipbin>
                            </el-tooltip>
                            <small class="truncate opacity-60" :title="url">{{url}}</small>
                          </div>
                        </div>
                      </div>

                      <div class="actions" v-show="!isPastServiceTime || !hardDisableEdit">
                        <el-tooltip content="Edit transcoding settings">
                          <ma-edit class="bly-edit icon-btn ma-btn" @click="editTranscodeAction(target)" />
                        </el-tooltip>
                        <el-tooltip content="Delete transcoding action">
                          <ma-delete class="bly-delete icon-btn ma-btn" @click="deleteTranscodeAction(target)" />
                        </el-tooltip>
                      </div>
                    </div>
                  </el-card>

                  <!-- OUTPUTS without streamkey -->
                  <el-card shadow="hover" :body-style="{ padding: '8px' }"
                    class="input"
                    v-for="(map, index) in basicOutputs"
                    :key="map.id + index">
                    <div>
                      {{map.output.displayName || map.output.name}}
                      <span class="output-type-tag" :class="getDisplayOutputType(map.output)">
                        {{getDisplayOutputType(map.output)}}
                      </span>
                      <br>
                      <small>{{map.output.description}}</small>


                      <div class="actions mt-1">
                        <el-tooltip content="Connection Info">
                          <small class="mt-1" @click="selectedOutput = {output: map.output, target: null}; outputReportDialog = true">
                              <ma-info class="el-tooltip bly-info icon-btn ma-btn" />
                          </small>
                        </el-tooltip>
                        <div v-show="!isPastServiceTime">
                          <el-tooltip content="more">
                            <el-dropdown trigger="click"
                              v-if="false"
                              v-show="isAdmin || eventAcl.clientAdmin || eventAcl.eventCoordinator
                                || eventAcl.ee || eventAcl.eo">
                              <ma-more class="bly-more icon-btn bi-rotate-90 ma-btn"></ma-more>
                              <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item icon="bi bly-delete"
                                  v-show="isAdmin || eventAcl.clientAdmin || eventAcl.eventCoordinator
                                    || eventAcl.ee"
                                  @click.native="deleteOutput(map.output)">
                                  Delete output
                                </el-dropdown-item>
                              </el-dropdown-menu>
                            </el-dropdown>
                          </el-tooltip>
                        </div>
                      </div>
                    </div>
                  </el-card>
                </div>
                <el-button size="mini" type="primary"
                  v-show="isAdmin || eventAcl.clientAdmin || eventAcl.eventCoordinator
                    || eventAcl.ee"
                  :disabled="!(!isPastServiceTime && isBeforeServiceTimeStart) || hardDisableEdit"
                  @click="openAddOutputDialog">
                  <span v-if="!hasOutputs">Add outputs</span>
                  <span v-if="hasOutputs">Change outputs</span>
                </el-button>
                <el-button
                  size="mini"
                  type="primary"
                  plain
                  v-show="isAdmin || eventAcl.clientAdmin || eventAcl.eventCoordinator || eventAcl.ee"
                  :disabled="!(!isPastServiceTime && isBeforeServiceTimeStart) || hardDisableEdit"
                  @click="openAddSingleOutputDialog">
                  Add single output
                </el-button>

                <!-- ADVANCE CONFIG FOR NORMAL USERS -->
                <div class="el-divider el-divider--horizontal cursor-pointer uppercase mt-6 mb-2 relative"
                  v-if="!isSysAdmin"
                  @click="showAdvance = !showAdvance">
                  <div class="el-divider__text is-left">Show advanced settings </div>
                  <div class="absolute right-0 -top-1.5 pl-3 bg-white" >
                    <svg viewBox="0 0 24 24" :class="{ 'transform rotate-180': showAdvance}" height="12" width="12" xmlns="http://www.w3.org/2000/svg" stroke-width="1.5"><path d="M23.25,7.311,12.53,18.03a.749.749,0,0,1-1.06,0L.75,7.311" fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                  </div>
                </div>
                <el-row :gutter="16" v-if="showAdvance && !isSysAdmin">
                  <el-col :span="12">
                    <div class="kicck-off">
                      <el-popover
                        placement="left"
                        width="300"
                        @show="edit('inputAudioPid', selectedEvent.inputAudioPid)"
                        v-model="showPopups.inputAudioPidPopup">
                        <p>
                          <el-input type="text" size="small" v-model="inputAudioPid"></el-input>
                        </p>
                        <div style="text-align: right; margin: 0">
                          <el-button size="mini" type="text"
                            @click="cancel('inputAudioPidPopup','inputAudioPid')">Cancel</el-button>
                          <el-button type="primary" size="mini"
                            @click="save('inputAudioPid', inputAudioPid)">Save</el-button>
                        </div>
                        <div class="content editable" slot="reference">
                          <div class="label">Input Audio Pid </div>
                          {{selectedEvent.inputAudioPid | defaultValue("----")}}
                          <ma-edit class="bly-edit"></ma-edit>
                        </div>
                      </el-popover>
                    </div>
                  </el-col>
                </el-row>
                <br><br>

                <div class="label">
                  Attachments
                  <div class="attachments-upload">
                    <el-upload
                      class="upload-demo"
                      action="uploadAction"
                      :auto-upload="false"
                      :on-change="handleUploadChange"
                      :show-file-list="false"
                      :multiple="false"
                      :accept="'.png, .jpg, jpeg, .doc, .docx, .pdf, .xls, .xlsx, .csv'">
                      <el-tooltip content="Upload another file" placement="left" slot="trigger">
                        <ma-upload class="icon-btn bly-upload ma-btn"></ma-upload>
                      </el-tooltip>
                    </el-upload>
                  </div>
                </div>
                <div
                  class="attachment-link"
                  v-for="(attachment, index) in eventAttachments"
                  :key="attachment.key"
                  :class="{'opacity-50': attachment.hidden}"
                  >
                  <div class="flex justify-between items-center w-full">
                    <span @click="downloadAttachment(attachment)" class="cursor-pointer">{{attachment.fileName}}</span>
                    <i
                      v-if="isSysAdmin"
                      class="cursor-pointer ml-2"
                      :class="attachment.hidden ? 'fas fa-eye' : 'fas fa-eye-slash'"
                      @click.stop="toggleAttachmentVisibility(attachment)"
                      :title="attachment.hidden ? 'Show attachment' : 'Hide attachment'"
                    ></i>
                  </div>
                </div>
                <div v-show="!eventAttachments">No Attachments</div>

                <div v-if="selectedEvent.commentaryLanguage">
                  <div class="label mt-4">
                    <i class="fas fa-globe-americas"></i> Commentary
                  </div>
                  <div class="mb-1">
                    <span>
                      Language:
                      <strong>
                        {{selectedEvent.commentaryLanguage}}
                      </strong>
                    </span>
                  </div>
                  <div>
                    <span>
                      User:
                      <strong v-if="isAdmin || eventAcl.clientAdmin || eventAcl.eo">
                        <el-popover
                          placement="right"
                          width="250"
                          v-model="showPopups.commentaryUserPopup"
                          trigger="click">
                          <div v-bar class="dd-popup-wrapper h-300">
                            <div>
                              <el-dropdown-item
                                  v-for="input in clientUsers"
                                  :key="input.id"
                                  @click.native="changeCommetnaryUser(input)"
                                  :title="input.email"
                                  >{{input.email | truncate(23)}}</el-dropdown-item>
                            </div>
                          </div>
                          <span class="el-dropdown-link" slot="reference">
                            {{selectedEvent.commentaryUser.email}}
                            <i class="el-icon-arrow-down el-icon--right"></i>
                          </span>
                        </el-popover>
                      </strong>
                      <strong v-else>{{selectedEvent.commentaryUser.email}}</strong>
                    </span>
                  </div>
                </div>

                <el-divider></el-divider>
                <el-row :gutter="16">
                  <el-col :span="24">
                      <el-button
                      type="primary"
                      size="small"
                      style="width:100%"
                      icon="bi bly-reload"
                      :disabled="isPastServiceTime"
                      v-if="hasOttOutputs"
                      v-show="isAdmin || eventAcl.clientAdmin || eventAcl.eo || eventAcl.ec"
                      @click="restartIncomingStream(selectedEvent.id)">
                      Restart application
                    </el-button>
                  </el-col>
                </el-row>
                <el-row :gutter="16" v-if="eventStatus !== 'COMPLETED'">
                  <el-col :span="24">
                    <el-button
                      type="info"
                      size="small"
                      style="width:100%"
                      :disabled="isPastServiceTime || isLive"
                      v-show="isAdmin || eventAcl.clientAdmin
                        || eventAcl.eventCoordinator || eventAcl.ee"
                      @click="setRescheduleEventDialog(true)">
                      Reschedule
                    </el-button>
                  </el-col>
                  <el-col :span="8">
                    <el-button
                      type="success"
                      size="small"
                      style="width:100%"
                      icon="bi bly-play"
                      :disabled="isPastServiceTime"
                      v-show="isSysAdmin || eventAcl.mct"
                      v-if="eventStatus !== 'LIVE'"
                      @click="startEventNow()">
                      Start now
                    </el-button>
                    <el-button
                      type="danger"
                      size="small"
                      style="width:100%"
                      icon="bi bly-stop"
                      v-show="isSysAdmin || eventAcl.mct"
                      v-if="eventStatus === 'LIVE'"
                      @click="stopEventNow()">
                      Stop now
                    </el-button>
                  </el-col>
                  <el-col :span="8">
                    <el-button
                      type="grey"
                      size="small"
                      style="width:100%"
                      v-if="selectedEvent.status !== 'POSTPONED'"
                      :disabled="isPastServiceTime || isLive"
                      v-show="isAdmin || eventAcl.clientAdmin
                        || eventAcl.eventCoordinator || eventAcl.ee"
                      @click="confirmPostpone()">
                      Postpone
                    </el-button>
                    <el-button
                      type="grey"
                      size="small"
                      style="width:100%"
                      v-if="selectedEvent.status === 'POSTPONED'"
                      :disabled="isPastServiceTime || isLive"
                      v-show="isAdmin || eventAcl.clientAdmin
                        || eventAcl.eventCoordinator || eventAcl.ee"
                      @click="setAsPending()">
                      Set Pedning
                    </el-button>
                  </el-col>
                  <el-col :span="8">
                    <!--
                    <el-button
                      type="danger"
                      size="small"
                      style="width:100%"
                      icon="bi bly-close"
                      :disabled="isPastServiceTime"
                      v-show="isAdmin || eventAcl.clientAdmin
                        || eventAcl.eventCoordinator || eventAcl.ee"
                      @click="confirmDelete()">
                      Cancel
                    </el-button>
                    -->
                    <el-button
                      type="danger"
                      size="small"
                      style="width:100%"
                      icon="bi bly-close"
                      :disabled="selectedEvent.status === 'CANCELLED'"
                      v-show="isAdmin || eventAcl.clientAdmin
                        || eventAcl.eventCoordinator || eventAcl.ee"
                      @click="cancelWithComment()">
                      Cancel
                    </el-button>
                  </el-col>
                </el-row>
                <el-row
                  :gutter="16"
                  class="mt-2"
                  v-show="canManageLiveMonitoring">
                  <el-col :span="24">
                    <div class="label">
                      Live monitoring
                      <div style="float:right">
                        <el-switch
                          :value="isLiveMonitoringAutoEnabled"
                          :disabled="liveMonitoringLoading"
                          active-text="Auto"
                          @change="setLiveMonitoringAuto">
                        </el-switch>
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <el-button
                      type="success"
                      size="small"
                      style="width:100%"
                      :loading="liveMonitoringLoading"
                      @click="startLiveMonitoringNow">
                      Start monitoring
                    </el-button>
                  </el-col>
                  <el-col :span="12">
                    <el-button
                      type="danger"
                      size="small"
                      style="width:100%"
                      :loading="liveMonitoringLoading"
                      @click="stopLiveMonitoringNow">
                      Stop monitoring
                    </el-button>
                  </el-col>
                </el-row>
                <div
                  v-if="selectedEvent.status === 'LIVE' || selectedEvent.status === 'COMPLETED'"
                  v-show="isAdmin || eventAcl.clientAdmin
                    || eventAcl.eventCoordinator || eventAcl.ee || eventAcl.eo">
                  <el-row :gutter="16">
                    <el-col :span="12">
                      <el-button
                        type="success"
                        size="small"
                        style="width:100%"
                        @click="sendNothingToReport(selectedEvent)">
                        Send NTR report
                      </el-button>
                    </el-col>
                    <el-col :span="12">
                      <el-button
                        type="danger"
                        size="small"
                        style="width:100%"
                        @click="openReportDialog(selectedEvent)">
                        Create report
                      </el-button>
                    </el-col>
                  </el-row>
                </div>
                <br><br>
                <el-button
                  size="small"
                  style="width:100%"
                  v-if="isAdmin || acl.clientAdmin || acl.ee || acl.eventCoordinator"
                  @click="duplicateBooking({extendedProps: selectedEvent})">
                  <ma-clipbin class="bly-clipbin"></ma-clipbin> Duplicate Booking
                </el-button>

                <el-button
                    size="small"
                    style="width:100%"
                    @click="createPdf(selectedEvent)">
                    Download PDF
                  </el-button>

                <br><br>
                <div class="sys-admin-menu" v-if="isSysAdmin">
                  <el-divider content-position="left">SYS ADMIN ONLY</el-divider>
                  <div><br></div>

                  <!-- AUDIT LOGS -->
                  <div class="label">
                    Audit Logs
                  </div>
                  <div v-if="eventAuditLogs && eventAuditLogs.length" class="mb-4">
                    <div v-for="log in eventAuditLogs" :key="log.id" class="text-xs mb-2 p-2 bg-[#13191D] rounded border border-gray-800">
                      <div><strong class="text-white">{{log.action}}</strong> -
                        <span :class="log.status === 'SUCCESS' ? 'text-green-400' : (log.status === 'ERROR' ? 'text-red-400' : 'text-yellow-400')">{{log.status}}</span>
                      </div>
                      <div class="text-gray-400">{{log.userEmail}} ({{log.createdAt | dateUtc}})</div>
                      <div class="mt-1 text-gray-300" v-if="log.message">{{log.message}}</div>
                    </div>
                  </div>
                  <div v-else class="text-xs text-gray-500 italic mb-4">No logs found for this event.</div>
                  <!-- /AUDIT LOGS -->

                  <div class="label">
                    Group ID
                    <el-input v-model="selectedEvent.groupId" class="mb-1"  ></el-input>
                    <button type="button" class="el-button el-button--primary el-button--mini" @click="save('groupId', selectedEvent.groupId)"><!----><!----><span> Save </span></button>

                  </div>
                  <div class="label">
                    MOS CHECKED
                    <div style="float:right">
                    <el-switch v-model="selectedEvent.mosChecked" @change="save('mosChecked', selectedEvent.mosChecked)"></el-switch></div>
                  </div>
                  <div><br></div>
                  <div class="label">
                    Event Status
                  </div>
                  <el-dropdown trigger="click"
                    style="width:100%">
                    <el-button type="primary"
                      size="small"
                      style="width:100%">
                      Change status<i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item
                        v-for="(status, key) in statusDisplayName"
                        :key="status"
                        @click.native="setStatus(key)">
                        <el-tag size="mini" :color="eventColorsSimple[key]" style="position:relative;top:4px;left:-4px;"></el-tag>
                        <span>{{status}}</span>
                        </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                  <div><br></div>
                  <div class="label" for="">Start Type <strong style="color: #000">{{this.selectedEvent.startType | defaultValue('---not set---')}}</strong></div>
                  <el-dropdown
                    style="width:100%">
                    <el-button type="default"
                      size="small"
                      style="width:100%">
                      Start type <i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item @click.native="save('startType','EVENT_NORMAL_START_STOP')">EVENT NORMAL START STOP</el-dropdown-item>
                      <el-dropdown-item @click.native="save('startType','EVENT_MANUAL_START')">EVENT MANUAL START</el-dropdown-item>
                      <el-dropdown-item @click.native="save('startType','EVENT_MANUAL_STOP')">EVENT MANUAL STOP</el-dropdown-item>
                      <el-dropdown-item @click.native="save('startType','EVENT_MANUAL_START_STOP')">EVENT MANUAL START STOP</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                  <div><br></div>
                  <div class="label mt-3">
                    INPUT STREAMS
                  </div>
                  <el-card shadow="hover" style="margin-bottom: 4px" :body-style="{ padding: '8px' }"  v-for="item in eventInputStreams" :key="item.id">
                    {{item.inputStream.name}}
                    <div style="float:right">
                      <ma-delete class="bly-delete" style="cursor: pointer" @click="unmapInputStream(item)"></ma-delete>
                    </div>
                  </el-card>
                  <el-dropdown>
                    <el-button type="primary"
                      size="mini">
                      Add Input Stream <i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item v-for="item in streamSources" @click.native="mapInputStream(item)" :key="item.id">{{item.name}}</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                  <div class="label mt-3">
                    OUTPUT STREAMS
                  </div>
                  <div>
                    <el-card shadow="hover" style="margin-bottom: 4px" :body-style="{ padding: '8px' }"
                     v-for="item in eventOutputStreams" :key="item.id">
                      {{item.outputStream.name}}
                      <div style="float:right">
                        <ma-delete class="bly-delete" style="cursor: pointer" @click="unmapOutputStream(item)"></ma-delete>
                      </div>
                    </el-card>
                    <el-dropdown>
                      <el-button type="primary"
                        size="mini">
                        Add Output Stream <i class="el-icon-arrow-down el-icon--right"></i>
                      </el-button>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-for="item in streamDestinations" @click.native="mapOutputStream(item)" :key="item.id">{{item.name}}</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                  <div class="label mt-3" for="">Delete Event</div>
                  <el-button
                    type="danger"
                    size="small"
                    style="width:100%"
                    @click="confirmDeleteEventPermanently()">
                    Delete Event Permanently
                  </el-button>
                </div>

                <br><br>
                <div class="updated-by">
                  <span>Updated by: </span>
                  {{selectedEvent.lastUpdatedBy.name}}
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>

    <!-- -------------------------------------------------------------------------- -->
    <!-- HLS PLAYER DIALOG -------------------------------------------------------- -->
    <!-- -------------------------------------------------------------------------- -->
    <HlsPlayer :visible.sync="hlsPlayer.visible" :url="hlsPlayer.url" :name="hlsPlayer.name" />

    <!-- -------------------------------------------------------------------------- -->
    <!-- ADD OUTPUTS DIALOG ------------------------------------------------------- -->
    <!-- -------------------------------------------------------------------------- -->
    <el-dialog
      title="Select output profile"
      :visible.sync="addOutputDialog"
      :close-on-click-modal="false"
      width="360px">
      <div class="dialog-form">
          <el-alert type="warning" v-show="hasOutputs" :closable="false">
            Existing outputs are going to be replaced.
          </el-alert>
          <br>
          <el-select
            v-model="outputProfileId"
            @clear="outputProfileId = null"
            clearable
            filterable
          >
            <el-option
              v-for="input in outputProfilesSorted"
              :key="input.id"
              :value="input.id"
              :label="input.name"
            ></el-option>
          </el-select>
          <el-checkbox v-model="shouldCopyStreamKeys" v-show="savedStreamKeys.length > 0">Copy stream keys</el-checkbox>
          <!-- {{savedStreamKeys}}
          <pre class="text-black text-xs">
            has keys to copy: {{savedStreamKeys.length > 0}}
            {{outputProfileId}}
            hasSelectedOutputProfileOTT : {{hasSelectedOutputProfileOTT}}
            {{selectedOutputProfile}}
          </pre> -->
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addOutputDialog = false">Cancel</el-button>
        <el-button type="primary" @click="addOutputs(shouldCopyStreamKeys)" v-loading="loading">
          Add
        </el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="Add single output"
      :visible.sync="addSingleOutputDialog"
      :close-on-click-modal="false"
      width="360px">
      <div class="dialog-form">
        <el-select
          v-model="selectedSingleOutputId"
          clearable
          filterable
          placeholder="Select output"
          class="w-full">
          <el-option
            v-for="output in availableSingleOutputs"
            :key="output.id"
            :value="output.id"
            :label="output.name" />
        </el-select>
        <p v-if="isAddingSingleOutput" class="mt-2 text-xs text-[#CDD6EE]">
          Adding output and refreshing event data...
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button :disabled="isAddingSingleOutput || loading" @click="addSingleOutputDialog = false">Cancel</el-button>
        <el-button
          type="primary"
          :disabled="!selectedSingleOutputId || isAddingSingleOutput || loading"
          :loading="isAddingSingleOutput || loading"
          @click="addSingleOutput">
          Add
        </el-button>
      </span>
    </el-dialog>

    <!-- -------------------------------------------------------------------------- -->
    <!-- SET OUTPUTS STREAMKEY DIALOG --------------------------------------------- -->
    <!-- -------------------------------------------------------------------------- -->
    <el-dialog
      title="Set stream key"
      :visible.sync="setStreamKeyDialog"
      :close-on-click-modal="false"
      width="360px">
      <div class="dialog-form" v-if="tempTarget">
          Stream key for <strong>{{tempTarget.name}}</strong>: <br>
          <el-input v-model="tempTarget.streamKey"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="setStreamKeyDialog = false">Cancel</el-button>
        <el-button type="primary" @click="updateStreamKey(tempTarget)" v-loading="loading">
          Save
        </el-button>
      </span>
    </el-dialog>

    <!-- -------------------------------------------------------------------------- -->
    <!-- SET Transcoder Profile DIALOG --------------------------------------------- -->
    <!-- -------------------------------------------------------------------------- -->
    <el-dialog
      title="Set transcoding channel"
      :visible.sync="setTranscoderDialog"
      :close-on-click-modal="false"
      width="360px">
      <div class="dialog-form" v-if="tempTarget">
          Select transcoding channel for all OTT outputs from the list
          <el-select
            v-model="tempTarget.transcoderProfile"
            @clear="tempTarget.transcoderProfile = null"
            clearable
            filterable
          >
            <el-option
              v-for="input in accountTranscodeProfiles"
              :key="input.id"
              :value="input.transcoderProfile"
              :label="input.name"
            ></el-option>
          </el-select>
      </div>
      <br>
      <div class="dialog-form" v-if="tempTarget && isSysAdmin">
          Or type it manualy
          <el-input v-model="tempTarget.sysAdminOption"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="setTranscoderDialog = false">Cancel</el-button>
        <el-button type="primary" @click="updateTranscoderProfile(tempTarget)" v-loading="loading">
          Save
        </el-button>
      </span>
    </el-dialog>

    <!-- -------------------------------------------------------------------------- -->
    <!-- SET OUTPUTS STREAMKEY DIALOG --------------------------------------------- -->
    <!-- -------------------------------------------------------------------------- -->
    <el-dialog
      title="Override OTT Application"
      :visible.sync="setOverrideOutputDialog"
      :close-on-click-modal="false"
      width="360px">
      <div class="dialog-form" v-if="tempTarget">
          Override OTT Application for <strong>{{tempTarget.name}}</strong>: <br>
          <el-input v-model="tempTarget.override"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="setOverrideOutputDialog = false">Cancel</el-button>
        <el-button type="primary" @click="setOverrideOutputMap(tempTarget)" v-loading="loading">
          Save
        </el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="Set autostart"
      :visible.sync="setAutostartDialog"
      :close-on-click-modal="false"
      width="360px">
      <div class="dialog-form" v-if="tempWowzaConfig">
          <div class="mb-3">
            <el-switch v-model="tempWowzaConfig.autostart" active-text="Enable autostart">
            </el-switch>
          </div>
          <div v-show="tempWowzaConfig.autostart">
            Autostart offset (min): <br>
            <el-input-number
              v-model="tempWowzaConfig.autostartOffsetMin"
              controls-position="right"
              :min="0"
              :max="serviceStartDuration"></el-input-number>
          </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="setAutostartDialog = false">Cancel</el-button>
        <el-button type="primary" @click="updateAutostart(tempWowzaConfig)" v-loading="loading">
          Save
        </el-button>
      </span>
    </el-dialog>

    <!-- -------------------------------------------------------------------------- -->
    <!-- EVENT REPORT ------------------------------------------------------------- -->
    <!-- -------------------------------------------------------------------------- -->
    <el-dialog
      title="Create report for booking"
      :visible.sync="reportEventDialog"
      width="80%"
      :close-on-click-modal="false">
      <div class="send-report-dialog">
        <el-row :gutter="24">
          <el-col :span="16">
            <el-form ref="createReportForm" :model="reportForm" label-position="top">
              <strong>Issue description</strong>
              <textarea
                class="w-full border p-2"
                rows="5"
                v-model="reportForm.description">
              </textarea>
            </el-form>
          </el-col>
          <el-col :span="8">
            <div v-if="selectedEvent" class="tx-report-booking-details">
              <strong>{{selectedEvent.name}}</strong>
              <el-row>
                <el-col :span="8">
                  <div class="label">Line-up</div>
                  <div class="content">{{selectedEvent.lineupTime | date('HH:mm')}}</div>
                </el-col>
                <el-col :span="8">
                  <div class="label">Kick-off</div>
                  <div class="content">{{selectedEvent.startTime | date('HH:mm')}}</div>
                </el-col>
                <el-col :span="8">
                  <div class="label">End Time</div>
                  <div class="content">{{selectedEvent.endTime | date('HH:mm')}}</div>
                </el-col>
              </el-row>

              <div class="label">Fixture</div>
              <div class="content">{{selectedEvent.fixture | defaultValue('---')}}</div>

              <div class="label">Property</div>
              <div class="content">{{selectedEvent.property | defaultValue('---')}}</div>

              <div class="label">Sport</div>
              <div class="content">{{selectedEvent.sport | defaultValue('---')}}</div>
            </div>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="reportEventDialog = false">Cancel</el-button>
        <el-button type="primary" @click="sendReport" v-loading="loading">Create</el-button>
      </span>
    </el-dialog>
    <!-- -------------------------------------------------------------------------- -->
    <!-- OUTPUTS REPORT ----------------------------------------------------------- -->
    <!-- -------------------------------------------------------------------------- -->
    <el-dialog
      v-if="selectedOutput.output"
      :title="'Output connection info \r\n' + selectedOutput.output.name"
      :visible.sync="outputReportDialog"
      width="360px"
      :close-on-click-modal="false">
      <div class="send-report-dialog" v-if="selectedOutput.output">
        <div class="d mb-3" v-if="selectedOutput.target">
          <div class="font-bold uppercase text-xs">Stream key</div>
          <div>{{selectedOutput.target.streamKey || 'not set'}}</div>
        </div>
        <div class="d" v-if="selectedOutput.output.url">
          <div class="font-bold uppercase text-xs">URL
            <span class="text-gray-500 font-normal lowercase">(click to copy)</span>
          </div>
          <div @click="copyCode(selectedOutput.output.url)" class="cursor-pointer hover:underline">{{selectedOutput.output.url}}</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="outputReportDialog = false" v-loading="loading">OK</el-button>
      </span>
    </el-dialog>

    <!-- -------------------------------------------------------------------------- -->
    <!-- TRANSCODE EDIT DIALOG --------------------------------------------------- -->
    <!-- -------------------------------------------------------------------------- -->
    <el-dialog
      title="Edit Transcoding Action"
      :visible.sync="showTranscodeEditDialog"
      width="560px"
      append-to-body
      :close-on-click-modal="false">
      <div v-if="transcodeEditForm.id">
        <div class="mb-4">
          <label class="block text-xs font-bold uppercase mb-1">Transcoding Channel</label>
          <el-select
            v-model="transcodeEditForm.transcodingProfileId"
            placeholder="Select Profile"
            class="w-full"
            filterable
            clearable>
            <el-option
              v-for="profile in accountTranscodeProfiles"
              :key="profile.id"
              :label="profile.name"
              :value="profile.id" />
          </el-select>
        </div>
        <div class="mb-4">
          <label class="block text-xs font-bold uppercase mb-1">Transcoding Outputs</label>
          <el-select
            v-model="transcodeEditForm.transcodingOutputIds"
            placeholder="Select Outputs"
            class="w-full"
            multiple
            filterable
            collapse-tags>
            <el-option
              v-for="output in accountTranscodeOutputs"
              :key="output.id"
              :label="output.name"
              :value="output.id" />
          </el-select>
        </div>

        <!-- Output Group Variable Overrides -->
        <div v-if="selectedOutputsWithGroups.length" class="mt-4 space-y-2">
          <div class="flex items-center gap-2 mb-3">
            <span class="text-xs font-bold uppercase text-gray-600">Output Destination Overrides</span>
            <span class="text-[10px] text-gray-400">per output group, applied at runtime</span>
          </div>

          <div
            v-for="output in selectedOutputsWithGroups"
            :key="output.id"
            class="border border-gray-200 rounded overflow-hidden"
          >
            <!-- Output header -->
            <div class="flex items-center justify-between bg-gray-100 px-3 py-1.5 border-b border-gray-200">
              <div class="flex items-center gap-2">
                <span class="text-xs font-bold text-gray-800">{{ output.name }}</span>
                <span v-if="output.groupName" class="text-[10px] font-mono text-amber-700 bg-amber-50 border border-amber-200 px-1.5 py-0.5 rounded">{{ output.groupName }}</span>
              </div>
            </div>

            <!-- Fields -->
            <div class="p-3 space-y-3 bg-white">
              <!-- Current destinations (read-only reference) -->
              <div v-if="output.destinations && output.destinations.length" class="space-y-1">
                <p class="text-[10px] font-bold uppercase text-gray-400">Current Destinations (from template)</p>
                <div v-for="(dest, dIdx) in output.destinations" :key="dIdx" class="grid grid-cols-2 gap-2">
                  <div class="text-[10px] font-mono text-gray-400 truncate px-2 py-1 bg-gray-50 border border-gray-200 rounded" :title="dest.Settings && dest.Settings[0] && dest.Settings[0].Url">
                    <span class="text-[9px] font-bold text-gray-300 uppercase mr-1">A</span>{{ (dest.Settings && dest.Settings[0] && dest.Settings[0].Url) || '—' }}
                  </div>
                  <div v-if="dest.Settings && dest.Settings[1]" class="text-[10px] font-mono text-gray-400 truncate px-2 py-1 bg-gray-50 border border-gray-200 rounded" :title="dest.Settings[1].Url">
                    <span class="text-[9px] font-bold text-gray-300 uppercase mr-1">B</span>{{ dest.Settings[1].Url || '—' }}
                  </div>
                </div>
              </div>

              <!-- Override destinations A / B -->
              <div class="grid grid-cols-2 gap-2">
                <div class="space-y-1">
                  <label class="block text-[10px] font-bold uppercase text-gray-500">Destination A Override</label>
                  <input
                    :value="(transcodeEditForm.variables.outputGroups[output.name] || {}).destinationA || ''"
                    @input="setOutputGroupVar(output.name, 'destinationA', $event.target.value)"
                    type="text"
                    placeholder="Leave blank to use template"
                    class="h-8 w-full rounded border border-gray-300 bg-white px-2.5 text-xs text-gray-800 outline-none focus:border-amber-500 focus:ring-1 focus:ring-amber-400/40"
                  />
                </div>
                <div class="space-y-1">
                  <label class="block text-[10px] font-bold uppercase text-gray-500">Destination B Override</label>
                  <input
                    :value="(transcodeEditForm.variables.outputGroups[output.name] || {}).destinationB || ''"
                    @input="setOutputGroupVar(output.name, 'destinationB', $event.target.value)"
                    type="text"
                    placeholder="Leave blank to use template"
                    class="h-8 w-full rounded border border-gray-300 bg-white px-2.5 text-xs text-gray-800 outline-none focus:border-amber-500 focus:ring-1 focus:ring-amber-400/40"
                  />
                </div>
              </div>

              <!-- Override name modifier -->
              <div class="space-y-1">
                <label class="block text-[10px] font-bold uppercase text-gray-500">Name Modifier Override</label>
                <input
                  :value="(transcodeEditForm.variables.outputGroups[output.name] || {}).nameModifier || ''"
                  @input="setOutputGroupVar(output.name, 'nameModifier', $event.target.value)"
                  type="text"
                  placeholder="Leave blank to use template value"
                  class="h-8 w-full rounded border border-gray-300 bg-white px-2.5 text-xs text-gray-800 outline-none focus:border-amber-500 focus:ring-1 focus:ring-amber-400/40"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showTranscodeEditDialog = false" size="small">Cancel</el-button>
        <el-button type="primary" @click="saveTranscodeAction" size="small" v-loading="loading">Save</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="Edit Stream Router Destination"
      :visible.sync="streamRouterEditDialog"
      width="30%"
      append-to-body>
      <el-alert
        title="Warning"
        type="warning"
        description="Changing this affects everything currently live with this output, and the configuration will persist for future events."
        show-icon
        :closable="false"
        class="mb-4">
      </el-alert>
      <div class="mb-2 text-sm text-gray-600">
        Output Type: <strong>SRT (CALLER)</strong>
      </div>
      <el-form :model="streamRouterForm" label-position="top">
        <el-form-item label="Destination (Host:Port)" required>
          <el-input v-model="streamRouterForm.destination" placeholder="1.2.3.4:5000"></el-input>
        </el-form-item>
        <el-form-item label="Latency (ms)">
          <el-input-number v-model="streamRouterForm.latency" :min="0" :step="10"></el-input-number>
        </el-form-item>
        <el-form-item label="Passphrase (Optional)">
          <el-input v-model="streamRouterForm.passphrase" show-password></el-input>
        </el-form-item>
        <el-form-item label="Stream ID (Optional)">
          <el-input v-model="streamRouterForm.streamId"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="streamRouterEditDialog = false">Cancel</el-button>
        <el-button type="primary" @click="saveStreamRouter" :loading="loading">Save</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="Edit Wowza Stream Target"
      :visible.sync="wowzaEditDialog"
      width="30%"
      append-to-body>
      <el-alert
        title="Warning"
        type="warning"
        description="Changing this affects everything currently live with this output, and the configuration will persist for future events."
        show-icon
        :closable="false"
        class="mb-4">
      </el-alert>
      <div class="mb-2 text-sm text-gray-600">
        Profile: <strong>RTMP</strong>
      </div>
      <el-form :model="wowzaForm" label-position="top">
        <el-form-item label="Destination App Name" required>
          <el-input v-model="wowzaForm.application" placeholder="Application Name"></el-input>
        </el-form-item>
        <el-form-item label="Destination Host" required>
          <el-input v-model="wowzaForm.host" placeholder="Host"></el-input>
        </el-form-item>
         <el-form-item label="Port" required>
          <el-input-number v-model="wowzaForm.port" :min="1" :max="65535"></el-input-number>
        </el-form-item>
        <el-form-item label="Stream Name" required>
          <el-input v-model="wowzaForm.streamName" placeholder="Stream Name"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="wowzaEditDialog = false">Cancel</el-button>
        <el-button type="primary" @click="saveWowza" :loading="loading">Save</el-button>
      </span>
    </el-dialog>

    <bly-live-input-update
      :visible.sync="liveInputUpdateVisible"
      :event="liveInputUpdateEvent"
    ></bly-live-input-update>

  </div>
</template>

<script>
import moment from 'moment';
import { mapState, mapActions, mapMutations } from 'vuex';
import { isMobileOnly } from 'mobile-device-detect';
import Vue from 'vue';

import config, { statusColors } from '../../config';
import { Amplify } from 'aws-amplify'
import { uploadData } from 'aws-amplify/storage';
import { generateClient } from 'aws-amplify/api';
import * as qlqueries from '../../graphql/queries';
import HlsPlayer from '../HlsPlayer.vue';
import { filterInputProfilesForClient } from '../../services/inputProfileAccess';
import { DEFAULT_INPUT_PROFILE_CONFIG } from '../../services/inputProfileConfig';
import { getTranscodeDestinationUrls } from '../../services/eventTranscodeUrls';
import { updateOutput, updateWowzaTarget } from '../../graphql/mutations';

const client = generateClient();

export default {
  name: 'AgendaPreview',
  components: { HlsPlayer },
  props: {
    eventsWithTheSameOTT: Array,
  },
  filters: {
    truncate: (value, length) => {
      const maxLength = length || 15;
      if (!value || typeof value !== 'string') return '';
      if (value.length <= maxLength) return value;
      return `${value.substring(0, maxLength)}...`;
    }
  },
  data() {
    return {
      loading: false,
      event: {},
      isMobileOnly,
      previewPushPanel: true,
      // dialogs
      outputReportDialog: false,
      hlsPlayer: {
        visible: false,
        url: '',
        name: '',
      },
      // forms
      eventAudioMapping: [
        {
          active: false,
          channelNo: 0,
          nameFieldL: 'Left',
          nameFieldR: 'Right',
        },
      ],
      searchInputOverride: '',
      // null = not editing; otherwise the JSON string the config editor works on
      inputProfileOverrideDraft: null,
      liveInputUpdateVisible: false,
      showAudioMappingForm: false,
      showAudioMappingEditForm: false,
      audioMappingForm: {
        active: false,
        channelNo: 1,
        nameFieldL: null,
        nameFieldR: null,
        stereo: true,
      },

      colors: statusColors,
      config,

      // popups
      showPopups: {
        fixturePopup: false,
        propertyPopup: false,
        sportPopup: false,
        descriptionPopup: false,
        editBackupValue: null,
        addOutput: false,
        downlinkConfigPopup: false,
        inputAudioPidPopup: false,
        inputVideoPidPopup: false,
        commentaryUserPopup: false,
        inputDetailsPopup: false,
        tagsPopup: false,
      },

      outputProfileId: null,

      fixture: '',
      sport: '',
      property: '',
      tags: [],
      description: '',
      clientName: '',
      lineupTime: '',
      inputVideoPid: '',
      inputInfo: '',
      inputAudioPid: '',
      audoMappingPopups: [],
      tempAudioMapping: {
        channelNo: 0,
        nameFieldL: '',
        nameFieldR: '',
        active: false,
      },

      selectedEvent: null,
      selectedOutput: {},
      showAdvance: false,

      // transcoding edit
      showTranscodeEditDialog: false,
      transcodeEditForm: {
        id: null,
        transcodingProfileId: null,
        transcodingOutputIds: [],
        version: null,
        variables: { outputGroups: {} },
      },

      addOutputDialog: false,
      addSingleOutputDialog: false,
      isAddingSingleOutput: false,
      selectedSingleOutputId: null,
      setStreamKeyDialog: false,
      setTranscoderDialog: false,
      setOverrideOutputDialog: false,
      tempTarget: null,
      reportEventDialog: false,

      tempWowzaConfig: null,
      setAutostartDialog: false,

      // Stream Router Edit
      streamRouterEditDialog: false,
      streamRouterForm: {
        destination: '',
        latency: 200,
        passphrase: '',
        streamId: '',
        targetId: null,
      },

      // Wowza Edit
      wowzaEditDialog: false,
      wowzaForm: {
        application: '',
        host: '',
        port: 1935,
        streamName: '',
        targetId: null,
      },

      rescheduleEventDialog: false,
      rescheduleForm: {
        startDate: null,
        lineupDate: null,
        endDate: null,
        endTime: null,
        startTime: null,
        eventId: null,
        lineupTime: null,
      },
      statusTagStyles: {
        REJECTED: 'danger',
        CANCALED: 'danger',
        APPROVED: 'success',
        'CLIENT CONFIRMED': 'clientconfirmed',
        MOS_CONFIRMED: 'mosconfirmed',
        CONFIRMED: 'success',
        COMPLETED: 'info',
        IN_PROGRESS: 'warning',
        LINEUP: '',
        SCHEDULED: '',
        SUBMITTED: 'info',
      },

      reportForm: {
        ntr: false,
        eventId: null,
        description: null,
      },
      downlinkConfigForm: {
        satelliteName: null,
        satelliteFrequency: null,
        satellitePolarization: null,
        symbolRate: null,
        BISS: null,
        service: null,
      },
      fileToUpload: null,
      datePickerOptions: {
        disabledDate(time) {
          return time.getTime() < new Date(new Date().setDate(new Date().getDate() - 1));
        },
      },
      uploadFileLoading: false,
      savedStreamKeys: [],
      shouldCopyStreamKeys: false,
      liveMonitoringLoading: false,
      

      // Router status polling interval
      statusPollingInterval: null,

      eventAuditLogs: [],
    };
  },

  computed: {
    ...mapState({
      userId: (state) => state.userAccount.userId,
      aclEx: (state) => state.userAccount.userPermissions,
      isAdmin: (state) => state.userAccount.isAdmin,
      isSysAdmin: (state) => state.userAccount.isSysAdmin,
      acl: (state) => state.userAccount.aclCurrent,
      userPermissions: (state) => state.userAccount.userPermissions,
      account: (state) => state.userAccount.account,
      client: (state) => state.userAccount.client,
      clients: (state) => state.userAccount.clients,
      storeSelectedEvent: (state) => state.schedule.selectedEvent,

      // event: (state) => state.schedule.selectedEvent,
      listEvents: (state) => state.schedule.listEvents,
      storeLoading: (state) => state.schedule.loading,
      loadings: (state) => state.schedule.loadings,
      events: (state) => state.schedule.events,
      eventStatuses: (state) => state.schedule.eventStatuses,
      eventColorsSimple: (state) => state.schedule.scheduleUIConfig.eventColorsSimple,
      statusDisplayName: (state) => state.schedule.statusDisplayName,
      eventTypes: (state) => state.schedule.eventTypes,
      inputs: (state) => state.schedule.inputs,
      inputProfiles: (state) => state.schedule.inputProfiles,
      outputs: (state) => state.schedule.outputs,
      outputProfiles: (state) => state.schedule.outputProfiles,
      eventStartType: (state) => state.schedule.eventStartType,
      eventsStats: (state) => state.schedule.eventsStats,
      awsExports: (state) => state.awsExports,

      appSettings: (state) => state.appSettings.settings,

      transcodingProfiles: (state) => state.schedule.transcodingProfiles,
      transcodingOutputs: (state) => state.schedule.transcodingOutputs,

      streamDestinations: (state) => state.stream.streamDestinations,
      streamSources: (state) => state.stream.streamSources,
      pictureFormats: (state) => state.input.pictureFormats,
      transcoderProfiles: (state) => state.permissions.transcoderProfiles,

      // Router status data
      routerOutputStatuses: (state) => state.routerAlt?.outputStatuses || {},
    }),

    bgStatusColor() {
      return status => `bg-${status}`;
    },
    isPanelLoading() {
      return !!(this.loading || this.uploadFileLoading || this.storeLoading);
    },

    hardDisableEdit() {
      const { code } = this.selectedEvent.customer;
      const accountCode = this.selectedEvent.account.code;
      return !this.isSysAdmin && `${code}.${accountCode}` === 'plp.ots';
    },

    shouldChangeToClientConfirmed() {
      const hasStatus = this.eventStatus === 'RECEIVED' || this.eventStatus === 'CONFIRMED' || this.eventStatus === 'AWAITING_SIGNAL';
      const isBeforeServiceTime = moment.utc(this.selectedEvent.serviceStartTime).subtract(1, 'hour').isAfter(moment.utc());
      console.log('shouldChangeToClientConfirmed', hasStatus, isBeforeServiceTime, this.eventStatus)
      return hasStatus && isBeforeServiceTime;
    },

    defaultInputPictureFormat() {
      return this.pictureFormats.filter((el) => el.name === '1080i29.97')[0];
    },

    defaultOutputPictureFormat() {
      return this.pictureFormats.filter((el) => el.name === '1080i25')[0];
    },
    eventInputStreams() {
      return this.selectedEvent && this.selectedEvent.inputStreams ? this.selectedEvent.inputStreams.items : [];
    },
    eventOutputStreams() {
      return this.selectedEvent && this.selectedEvent.outputStreams ? this.selectedEvent.outputStreams.items : [];
    },

    clientUsers() {
      if (!this.clients) return [];
      const users = this.clients[this.eventClient.id].users.items.map((el) => el.user);
      const usersIds = users.map((user) => user.id);
      const filtered = users.filter(({ id }, index) => !usersIds.includes(id, index + 1));
      return filtered;
    },
    drawerSize() {
      console.log('window.screen.width;', window.screen.width);
      if (window.screen.width < 355) return '320px';
      return '360px';
    },

    eventAcl() {
      const aclCurrent = {};
      if (this.isAdmin) {
        aclCurrent.admin = true;
        return aclCurrent;
      }
      // read the selected event, not `this.event` - the latter is only filled on
      // route load / after a mutation, so it goes stale when picking from the list
      const { code } = this.eventClient;
      const accountCode = this.eventAccount.code;
      const clientPermissions = code && this.userPermissions[code];
      if (!clientPermissions) return aclCurrent;

      // account permissions carry the claims (cfm, mct, ...) - apply them before the
      // role flags, otherwise a ca/ec shortcut would drop every other claim
      const account = clientPermissions.accounts[accountCode];
      if (account) {
        account.permissions.forEach((item) => {
          aclCurrent[item] = true;
        });
      }

      const clientAccount = clientPermissions.accounts[code];
      const rolePermissions = (clientAccount && clientAccount.permissions) || [];
      if (rolePermissions.indexOf('ca') > -1) aclCurrent.clientAdmin = true;
      if (rolePermissions.indexOf('ec') > -1) {
        aclCurrent.eventCoordinator = true;
        aclCurrent.ec = true;
      }
      return aclCurrent;
    },

    eventDate() {
      return this.selectedEvent ? this.selectedEvent.startTime.split('T')[0] : '';
    },

    eventAccount() {
      return this.selectedEvent ? this.selectedEvent.account : { name: '' };
    },

    eventClient() {
      return this.selectedEvent ? this.selectedEvent.customer : { name: '' };
    },

    eventTitle() {
      return this.selectedEvent ? this.selectedEvent.fixture : '';
    },

    eventStatus() {
      return this.selectedEvent ? this.selectedEvent.status : null;
    },

    eventAttachments() {
      if (!this.selectedEvent || !this.selectedEvent.attachments) return [];

      let attachments = [];
      try {
        const attStr = this.selectedEvent.attachments.trim();
        if (attStr.startsWith('[')) {
           // New unified list format
           attachments = JSON.parse(attStr);
        } else if (attStr.startsWith('{')) {
           // Interim object format
           const json = JSON.parse(attStr);
           if (json.tagAttachments) {
             attachments = attachments.concat(json.tagAttachments.map(a => ({ ...a, type: 'TAG' })));
           }
           if (json.regularAttachments) {
             attachments = attachments.concat(json.regularAttachments.map(a => ({ ...a, type: 'REGULAR' })));
           }
        } else {
           // Old string format
           const list = this.selectedEvent.attachments.split(',');
           const clientId = this.eventClient.code;
           const accountId = this.eventAccount.code;
           attachments = list.filter(f => f).map(f => ({
             fileName: f,
             key: `${clientId}/${accountId}/${f}`,
             type: 'REGULAR'
           }));
        }
      } catch (e) {
        console.error('Error parsing attachments', e);
        // Fallback
        const list = this.selectedEvent.attachments.split(',');
         const clientId = this.eventClient.code;
         const accountId = this.eventAccount.code;
         attachments = list.filter(f => f).map(f => ({
             fileName: f,
             key: `${clientId}/${accountId}/${f}`,
             type: 'REGULAR'
         }));
      }
      if(this.isSysAdmin) {
        return attachments;
      }

      return attachments.filter(a => !a.hidden);
    },

    eventStatusDisplayName() {
      return this.selectedEvent ? this.statusDisplayName[this.selectedEvent.status] : '';
    },

    eventServiceTimeRange() {
      return this.selectedEvent
        ? {
          start: this.selectedEvent.serviceStartTime,
          end: this.selectedEvent.serviceEndTime,
        } : null;
    },

    serviceStartDuration() {
      const duration = moment.duration(
        moment(this.selectedEvent.startTime).diff(moment(this.selectedEvent.serviceStartTime)),
      );
      return Math.floor(duration.asMinutes());
    },

    hasServiceTimeStarted() {
      const nowUtc = moment().utc();
      const { start, end } = this.eventServiceTimeRange;
      return moment(nowUtc)
        .isBetween(moment(start), moment(end), null, '[]');
    },

    isPastServiceTime() {
      const nowUtc = moment().utc();
      const { end } = this.eventServiceTimeRange;
      return moment(nowUtc).isAfter(moment(end));
    },

    isLive() {
      return this.selectedEvent.status === 'LIVE';
    },

    eventConfig() {
      return this.parseEventConfig(this.selectedEvent && this.selectedEvent.config);
    },

    // per-event replacement for the input profile config, same shape as InputProfile.config
    inputProfileOverride() {
      const override = this.eventConfig.inputProfileOverride;
      return override && typeof override === 'object' ? override : null;
    },

    // The dialog reads the override off the event, the way the monitoring store hands it over.
    liveInputUpdateEvent() {
      if (!this.selectedEvent) return null;
      return { ...this.selectedEvent, inputProfileOverride: this.inputProfileOverride };
    },

    inputProfileOverrideSummary() {
      const override = this.inputProfileOverride;
      if (!override) return 'None';
      const connections = (override.connection || [])
        .map((connection) => `${connection.ip || 'any'}:${connection.port}`)
        .join(', ');
      return [override.protocol, override.mode, connections].filter(Boolean).join(' ');
    },

    isLiveMonitoringAutoEnabled() {
      return this.eventConfig.liveMonitoring === true;
    },

    canManageLiveMonitoring() {
      return !!this.selectedEvent && (
        this.isAdmin
        || this.eventAcl.clientAdmin
        || this.eventAcl.eventCoordinator
        || this.eventAcl.ee
        || this.eventAcl.eo
      );
    },

    isBeforeServiceTimeStart() {
      // return this.selectedEvent.status === 'LIVE';
      const nowUtc = moment().utc();
      const { start } = this.eventServiceTimeRange;
      return moment(nowUtc).isBefore(moment(start));
    },

    claimsCanEdit() {
      const accountId = this.eventAccount.code;
      const clientId = this.eventClient.code;
      return [`ee.${accountId}.${clientId}`, `eo.${accountId}.${clientId}`];
    },

    claimsCanAccess() {
      const accountId = this.eventAccount.code;
      const clientId = this.eventClient.code;
      return [
        `ev.${accountId}.${clientId}`,
        `ee.${accountId}.${clientId}`,
        `eo.${accountId}.${clientId}`,
      ];
    },

    audioClaimsCanAccess() {
      const accountId = this.eventAccount.code;
      const clientId = this.eventClient.code;
      return [
        `ev.${accountId}.${clientId}`,
        `ee.${accountId}.${clientId}`,
        `eo.${accountId}.${clientId}`,
        `ca.${clientId}.${clientId}`,
        `aa.${accountId}.${clientId}`,
        `ec.${clientId}.${clientId}`,
      ];
    },

    audioClaimsCanEdit() {
      const accountId = this.eventAccount.code;
      const clientId = this.eventClient.code;
      return [
        `ee.${accountId}.${clientId}`,
        `eo.${accountId}.${clientId}`,
        `ca.${clientId}.${clientId}`,
        `aa.${accountId}.${clientId}`,
        `ec.${clientId}.${clientId}`,
      ];
    },

    unusedOutputs() {
      return this.accountOutputs
        .filter((item) => {
          const isAssigned = this.sortedActions
            .filter((action) => item.id === action.assignedOutput.id);
          return isAssigned.length === 0;
        })
        .sort((a, b) => {
          if (a.name < b.name) { return -1; }
          if (a.name > b.name) { return 1; }
          return 0;
        })
        .map((item) => ({
          id: item.id,
          name: item.name,
          selected: false,
          description: item.description,
        }));
    },

    availableSingleOutputs() {
      const assignedOutputIds = new Set(
        (this.selectedEvent?.outputs?.items || [])
          .map((item) => item?.output?.id)
          .filter(Boolean),
      );
      const outputs = this.outputs?.items || [];
      const accessClaim = `usr.${this.eventAccount.code}.${this.eventClient.code}`;
      const customerClaim = `usr.${this.eventClient.code}`;

      const accessibleOutputs = this.isSysAdmin
        ? outputs
        : outputs.filter((output) => {
          const claims = output?.claimsCanAccess || [];
          return claims.includes(accessClaim) || claims.includes(customerClaim);
        });

      return accessibleOutputs
        .filter((output) => !assignedOutputIds.has(output.id))
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((output) => ({
          id: output.id,
          name: output.displayName || output.name,
        }));
    },

    accountTranscodeProfiles() {
      const items = this.transcodingProfiles && this.transcodingProfiles.items
        ? this.transcodingProfiles.items
        : [];
      return items.map(item => ({
        id: item.id,
        name: item.name
      }))
      .sort((a, b) => a.name.localeCompare(b.name));
    },

    accountTranscodeOutputs() {
      const items = this.transcodingOutputs && this.transcodingOutputs.items
        ? this.transcodingOutputs.items
        : [];
      return items.map(item => {
        let parsedConfig = null;
        if (item.config) {
          try { parsedConfig = typeof item.config === 'string' ? JSON.parse(item.config) : item.config; } catch (e) { /* ignore */ }
        }
        return { id: item.id, name: item.name, parsedConfig };
      })
      .sort((a, b) => a.name.localeCompare(b.name));
    },

    selectedOutputsWithGroups() {
      return this.transcodeEditForm.transcodingOutputIds.map(id => {
        const output = this.accountTranscodeOutputs.find(o => o.id === id);
        if (!output) return { id, name: id, groupName: null, destinations: [] };
        const cfg = output.parsedConfig;
        const groupName = cfg?.outputGroup?.name || null;
        const destinations = cfg?.destinations || [];
        return { id, name: output.name, groupName, destinations };
      });
    },


    accountOutputs() {
      const accessClaim = `usr.${this.eventAccount.code}.${this.eventClient.code}`;
      const hasItems = !!this.outputs.items;
      if (!hasItems) return [];
      return this.outputs.items
        .filter((item) => {
          const hasPermission = item.claimsCanAccess.indexOf(accessClaim) !== -1;
          return hasPermission;
        })
        .sort((a, b) => {
          if (a.name < b.name) { return -1; }
          if (a.name > b.name) { return 1; }
          return 0;
        });
    },

    allInputsFiltered() {
      return this.allInputs
        .filter((item) => {
          if(this.searchInputOverride === '' || this.searchInputOverride.length < 3) return true;
          return item.name.toLowerCase().includes(this.searchInputOverride.toLowerCase());
        });
    },

    allInputs() {
      console.log('%c inputs', 'color: red', this.inputs);
      const hasItems = !!this.inputs.items;
      if (!hasItems) return [];
      return this.inputs.items
        .slice(0)
        .sort((a, b) => {
          if (a.name < b.name) { return -1; }
          if (a.name > b.name) { return 1; }
          return 0;
        });
    },

    accountInputs() {
      const accessClaim = `usr.${this.eventClient.code}`;
      const hasItems = !!this.inputs.items;
      if (!hasItems) return [];
      return this.inputs.items.filter((item) => {
        const hasPermission = item.claimsCanAccess.indexOf(accessClaim) !== -1 || item.claimsCanAccess.indexOf(this.accountAccessClaim) !== -1;
        return hasPermission;
      })
        .sort((a, b) => {
          if (a.name < b.name) { return -1; }
          if (a.name > b.name) { return 1; }
          return 0;
        });
    },

    inputsById() {
      const elements = {};

      this.accountInputs.forEach((item) => {
        elements[item.id] = item;
      });

      return elements;
    },

    accountInputProfiles() {
      if (!this.inputProfiles.items) return [];
      return filterInputProfilesForClient(this.inputProfiles.items, this.eventClient.code);
    },

    selectedInputProfile() {
      if (!this.selectedEvent) return null;
      return this.selectedEvent.inputProfile || null;
    },

    // selectedEvent() {
    //   return this.event;
    // },

    basicOutputs() {
      if (!this.selectedEvent) return [];
      const outputs = this.selectedEvent.outputs.items;
      const actions = this.selectedEvent.actions.items;

      const basicOutputs = outputs ? outputs.filter((output) => {
        console.log(output);
        if (!output) return false;
        const { id } = output.output;
        const result = actions.filter((action) => {
          const hasAction = id === action.assignedOutput.id;
          return hasAction;
        });

        return result.length === 0;
      }) : [];
      return basicOutputs.sort();
    },

    actions() {
      if (!this.selectedEvent) return [];
      const actions = this.selectedEvent.actions.items
        .filter((action) => action.actionType !== 'TRANSCODE')
        .map((action) => {
          const actionOutputMap = this.selectedEvent.outputs.items
            .find((el) => action.assignedOutput.id === el.output.id);

          return {
            ...action,
            actionOutputMap,
          };
        });
      console.log('%cActions', 'color:lime', actions);
      return actions;
    },

    transcodeActions() {
      if (!this.selectedEvent || !this.selectedEvent.actions) return [];
      return this.selectedEvent.actions.items.filter((action) => action.actionType === 'TRANSCODE');
    },

    sortedActions() {
      if (!this.selectedEvent) return [];
      const sorted = this.actions
        .slice(0)
        .sort((a, b) => {
          if (a.assignedOutput.name < b.assignedOutput.name) { return -1; }
          if (a.assignedOutput.name > b.assignedOutput.name) { return 1; }
          return 0;
        });
      return sorted;
    },

    sortedAudioMapping() {
      const sorted = this.selectedEvent.audioMapping.items
        .slice(0)
        .sort((a, b) => {
          if (a.channelNo < b.channelNo) { return -1; }
          if (a.channelNo > b.channelNo) { return 1; }
          return 0;
        });
      return sorted;
    },

    inputName() {
      const { input, inputProfile } = this.selectedEvent;
      if (input && input.name) return input.name;
      if (inputProfile && inputProfile.name) return inputProfile.name;
      return '--- not set ---';
    },

    inputStatus() {
      return (input) => (input && input.status === 'OFFLINE' ? input.status : '');
    },
    hasInputDetailsEnabled() {
      const { input } = this.selectedEvent;
      return input ? input.requireDetails : false;
    },

    overrideInputName() {
      const { inputOverride } = this.selectedEvent;
      return inputOverride && inputOverride.name ? inputOverride.name : 'Override input';
    },

    inputDetails() {
      const { input } = this.selectedEvent;
      return input && input.name ? input : {};
    },

    downLinkConfig() {
      const eventHasDownlinkConfig = this.selectedEvent && this.selectedEvent.inputDownlinkConfig;
      if (eventHasDownlinkConfig) return this.selectedEvent.inputDownlinkConfig;
      if (this.inputDetails.type === 'DOWNLINK' && this.inputDetails.downlinkConfig) return this.inputDetails.downlinkConfig;
      return null;
    },

    accountAccessClaim() {
      if (!this.selectedEvent) return '';
      return `usr.${this.selectedEvent.account.code}.${this.selectedEvent.customer.code}`;
    },

    hasOutputs() {
      return this.sortedActions.length !== 0 || this.basicOutputs.length !== 0;
    },

    hasOttOutputs() {
      // if(!this.hasOutputs) return false;
      const actions = this.sortedActions.filter((action) => action.assignedOutput.outputType === 'OTT');
      const outputs = this.basicOutputs.filter((output) => output.output.outputType === 'OTT');
      return actions.length > 0 || outputs.length > 0;
    },
    serviceStartTimeOffsetMin() {
      return moment(this.selectedEvent.lineupTime).diff(this.selectedEvent.serviceStartTime, 'minutes');
    },

    // Router Status Computed Properties
    getOutputRouterStatus() {
      return (outputId) => {
        const eventStatuses = this.routerOutputStatuses[`event_${this.selectedEvent.id}`];
        if (!eventStatuses) return null;
        return eventStatuses[outputId] || null;
      };
    },

    getEventOutputRouterStatuses() {
      return (eventId) => {
        return this.routerOutputStatuses[`event_${eventId}`] || {};
      };
    },

    getReadableRouterStatus() {
      return (outputId, outputType = 'OTT') => {
        const status = this.getOutputRouterStatus(outputId)?.status;
        if (!status) return 'Unknown';

        // Map status codes to readable labels
        const statusMappings = {
          'OTT': {
            'Disabled': 'Not Active',
            'Active': 'Streaming',
            'Error': 'Stream Error',
            'Waiting': 'Waiting for Stream',
            'Inactive': 'Inactive'
          },
          'ROUTE': {
            'Undefined': 'Not Set',
            'Disabled': 'Not Active',
            'Active': 'Streaming',
            'Error': 'Stream Error',
            'Waiting': 'Waiting for Stream',
            'Inactive': 'Inactive'
          }
        };

        return statusMappings[outputType]?.[status] || status;
      };
    },

    getRouterStatusClass() {
      return (outputId, outputType = 'OTT') => {
        const status = this.getOutputRouterStatus(outputId)?.status;
        if (!status) return 'status-unknown';

        // Map status codes to CSS classes
        const statusClasses = {
          'OTT': {
            'Disabled': 'status-disabled',
            'Active': 'status-active',
            'Error': 'status-error',
            'Waiting': 'status-waiting',
            'Inactive': 'status-inactive'
          },
          'ROUTE': {
            'Undefined': 'status-undefined',
            'Disabled': 'status-disabled',
            'Active': 'status-active',
            'Error': 'status-error',
            'Waiting': 'status-waiting',
            'Inactive': 'status-inactive'
          }
        };

        return statusClasses[outputType]?.[status] || 'status-unknown';
      };
    },
    outputProfilesSorted() {
      if (!this.selectedEvent) return []
      this.customerAccessClaim = `usr.${this.selectedEvent.customer.code}`;
      if (!this.outputProfiles.items) return [];
      const profiles = this.outputProfiles.items
        .filter((item) => {
          const hasPermission = item.claimsCanAccess.indexOf(this.accountAccessClaim) !== -1 || item.claimsCanAccess.indexOf(this.customerAccessClaim) !== -1;
          return hasPermission;
        }).sort((a, b) => {
          if (a.name < b.name) { return -1; }
          if (a.name > b.name) { return 1; }
          return 0;
        });
      if (this.isMobileOnly) profiles.unshift({ name: 'None', id: -1 });
      return profiles;
    },
    selectedOutputProfile() {
      return this.outputProfilesSorted.filter((profile) => {
          return profile.id === this.outputProfileId;
      })[0] || {};
    },
    hasSelectedOutputProfileOTT() {
      const { outputs } = this.selectedOutputProfile;
      if (!outputs) return false;

      return outputs.items.filter((map) => {
        return map.output.outputType === 'OTT';
      }).length > 0;
    },
  },

  async mounted() {
    if (this.$route.params.id) {
      this.loading = true;
      const event = await this.getEvent(this.$route.params.id);
      this.processEvent(event);
      this.loading = false;
    }
  },

  beforeDestroy() {
    // Clean up polling interval to prevent memory leaks
    this.stopOutputStatusPolling();
  },

  watch: {
    async '$route.params.id'(newId) {
      console.log('rout changed agenda preview', newId);
      this.loading = true;
      const event = await this.getEvent(newId);
      this.processEvent(event);
      this.loading = false;
    },
    storeSelectedEvent(newVal) {
      if (!newVal) return;
      this.syncPreviewEvent(newVal);
    },
    selectedEvent(newVal) {
      if (!newVal && this.isMobileOnly) {
        this.previewPushPanel = false;
        // Clear router status polling when no event selected
        this.stopOutputStatusPolling();
        return;
      }
      this.fetchTranscodingInfo();
      this.lineupTime = newVal.lineupTime;
      this.audioMappingForm.channelNo = this.sortedAudioMapping.length + 1;

      // Initialize router status polling for live events
      this.initializeOutputStatusPolling(newVal);

      this.rescheduleForm = {
        endDate: newVal.endTime.split('T')[0],
        startDate: newVal.startTime.split('T')[0],
        lineupDate: newVal.lineupTime.split('T')[0],
        eventId: newVal.id,
        endTime: newVal.endTime.split('T')[1],
        startTime: newVal.startTime.split('T')[1],
        lineupTime: newVal.lineupTime.split('T')[1],
        expectedVersion: newVal.version,
        accountId: this.eventAccount.code,
        clientId: this.eventClient.code,
        tailTimeMin: newVal.tailTimeMin,
        headTimeMin: newVal.headTimeMin,
      };
      this.downlinkConfigForm = {
        satelliteName: null,
        satelliteFrequency: null,
        satellitePolarization: null,
        symbolRate: null,
        BISS: null,
        service: null,
      };
      if (this.downLinkConfig)  this.downlinkConfigForm = JSON.parse(JSON.stringify(this.downLinkConfig));
      this.previewPushPanel = true;
      if (this.isSysAdmin && newVal.id) {
        this.fetchAuditLogs(newVal.id);
      }
    },

    event(newVal) {
      if (!newVal) return;
      this.syncPreviewEvent(newVal);
    },
  },

  methods: {

    syncPreviewEvent(newVal) {
      Vue.set(this, 'selectedEvent', newVal);
      this.fixture = newVal.fixture;
      this.sport = newVal.sport;
      this.property = newVal.property;
      this.tags = newVal.tags ? [...newVal.tags] : [];
      this.description = newVal.description;
      this.lineupTime = newVal.lineupTime;
      this.inputAudioPid = newVal.inputAudioPid;
      this.inputVideoPid = newVal.inputVideoPid;
      // this.clientName = newVal.customer.name;
    },
    async fetchTranscodingInfo() {
      // Always fetch all available profiles and outputs so we can see names even if the event actions are empty
      this.$store.dispatch('schedule/fetchTranscodingProfiles');
      this.$store.dispatch('schedule/fetchTranscodingOutputs');
    },

    async fetchAuditLogs(eventId) {
      if (!eventId) return;
      try {
        const result = await client.graphql({
          query: qlqueries.auditLogsByTarget,
          variables: { targetId: eventId, sortDirection: 'DESC', limit: 100 },
        });
        this.eventAuditLogs = result.data.auditLogsByTarget.items || [];
      } catch (err) {
        console.error('Failed to fetch event audit logs', err);
        this.eventAuditLogs = [];
      }
    },
    ...mapActions({
      getEvent: 'schedule/getEvent',
      deleteEvent: 'schedule/deleteEvent',
      updateEvent: 'schedule/updateEventAgenda',
      rescheduleEvent: 'schedule/rescheduleEvent',
      deleteEventAudioChannel: 'schedule/deleteEventAudioChannel',
      createEventAudioChannel: 'schedule/createEventAudioChannel',
      updateEventAudioChannel: 'schedule/updateEventAudioChannel',

      // New Router API methods
      routerStartEvent: 'routerAlt/routerStartEvent',
      routerStopEvent: 'routerAlt/routerStopEvent',
      routerRestartEvent: 'routerAlt/routerRestartEvent',
      routerStopOutput: 'routerAlt/routerStopOutput',
      routerStartTarget: 'routerAlt/routerStartTarget',
      routerStopTarget: 'routerAlt/routerStopTarget',
      routerSetStreamKey: 'routerAlt/routerSetStreamKey',

      // Router Status Actions
      fetchEventOutputStatuses: 'routerAlt/fetchEventOutputStatuses',
      fetchOutputStatus: 'routerAlt/fetchOutputStatus',
      fetchOutputsStatuses: 'routerAlt/fetchOutputsStatuses',
      startEventStatusPolling: 'routerAlt/startEventStatusPolling',
      stopEventStatusPolling: 'routerAlt/stopEventStatusPolling',

      // Legacy methods (kept for backward compatibility)
      startStreamTarget: 'schedule/startStreamTarget',
      stopStreamTarget: 'schedule/stopStreamTarget',
      restartIncomingStream: 'schedule/restartIncomingStream',
      eventStartLiveMonitoring: 'schedule/eventStartLiveMonitoring',
      eventStopLiveMonitoring: 'schedule/eventStopLiveMonitoring',
      setStreamKey: 'schedule/setStreamKey',
      setEventOutputMapOverride: 'schedule/setEventOutputMapOverride',
      eventManualStart: 'schedule/eventManualStart',
      eventManualStop: 'schedule/eventManualStop',
      eventInputChange: 'schedule/eventInputChange',
      eventOutputAdd: 'schedule/eventOutputAdd',
      eventOutputRemove: 'schedule/eventOutputRemove',
      addEventReport: 'schedule/addEventReport',
      eventOutputProfileChange: 'schedule/eventOutputProfileChangeAgenda',
      updateWowzaConfig: 'schedule/updateWowzaConfig',
      createDownlinkConfig: 'schedule/createDownlinkConfig',
      signDownloadUrl: 'schedule/signDownloadUrl',

      updateAppSetting: 'appSettings/updateAppSetting',
      createPdf: 'schedule/createPdf',

      mapEventInputStream: 'schedule/mapEventInputStream',
      mapEventOutputStream: 'schedule/mapEventOutputStream',

      unmapEventInputStream: 'schedule/unmapEventInputStream',
      unmapEventOutputStream: 'schedule/unmapEventOutputStream',
      updateWowzaTarget: 'schedule/updateWowzaTarget',
      eventChangeStatus: 'schedule/eventChangeStatus',
      patchEventAction: 'schedule/patchEventAction',
      removeEventActionAndDependencies: 'schedule/removeEventActionAndDependencies',
    }),
    ...mapMutations({
      setActiveEvent: 'schedule/setActiveEvent',
      setSelectedEventProperty: 'schedule/setSelectedEventProperty',
      setRescheduleEventDialog: 'schedule/setRescheduleEventDialog',
      setShowCreateEventDialog: 'schedule/setShowCreateEventDialog',
      setBookingClone: 'schedule/setBookingClone',
    }),

    getDisplayOutputType(output) {
      if (!output) return '';
      const outputType = output.outputType;
      if (outputType === 'TECHEX') {
        if (output.url && output.url.startsWith('srt')) return 'CING-SRT';
        if (output.url && output.url.startsWith('rtp')) return 'CING-RTP';
        return 'CING';
      }
      return outputType;
    },

    // Router Status Lifecycle Management
    initializeOutputStatusPolling(event) {
      if (!event) return;

      // Clear existing polling first
      this.stopOutputStatusPolling();

      // Check if event is currently live
      const now = moment();
      const eventStart = moment(event.startTime);
      const eventEnd = moment(event.endTime);
      const isLive = now.isBetween(eventStart, eventEnd);

      console.log('Event live status:', isLive, event);

        // Start polling for event outputs
        this.fetchEventOutputStatuses({eventId: event.id});

      if (isLive) {
        // Set up polling interval (every 60 seconds for live events)
        this.statusPollingInterval = setInterval(() => {
          this.fetchEventOutputStatuses({eventId: event.id});
        }, 60000);
      }
    },

    stopOutputStatusPolling() {
      if (this.statusPollingInterval) {
        clearInterval(this.statusPollingInterval);
        this.statusPollingInterval = null;
        console.log('Stopped router status polling');
      }
    },

    openAddOutputDialog() {
      this.savedStreamKeys = this.sortedActions
        .filter((action) => {
          return action.assignedOutput.outputType === 'OTT';
        })
        .map((action) => {
          const [target] = action.configWowza.targets.items;
          return {
            streamKey: target.streamKey,
            target: target.target,
          };
        })
        .filter((action) => {
          return action.streamKey;
        });
      this.addOutputDialog = true;
    },

    openAddSingleOutputDialog() {
      this.selectedSingleOutputId = null;
      this.addSingleOutputDialog = true;
    },

    async addSingleOutput() {
      if (!this.selectedSingleOutputId) return;

      this.isAddingSingleOutput = true;
      const payload = {
        accountId: this.eventAccount.code,
        clientId: this.eventClient.code,
        eventId: this.selectedEvent.id,
        outputIds: [this.selectedSingleOutputId],
        claimsCanAccess: this.selectedEvent.claimsCanAccess || [],
        claimsCanEdit: this.selectedEvent.claimsCanEdit || [],
      };
      try {
        const result = await this.eventOutputAdd(payload);
        if (result?.error) {
          this.$message.error(result?.message?.[0]?.message || 'Failed to add output');
          return;
        }

        this.addSingleOutputDialog = false;
        this.selectedSingleOutputId = null;
      } finally {
        this.isAddingSingleOutput = false;
      }
    },

    editTranscodeAction(action) {
      let savedOutputGroups = {};
      if (action.config) {
        try {
          const parsed = typeof action.config === 'string' ? JSON.parse(action.config) : action.config;
          savedOutputGroups = parsed?.variables?.outputGroups || {};
        } catch (e) { /* ignore */ }
      }
      this.transcodeEditForm = {
        id: action.id,
        transcodingProfileId: action.transcodingProfile ? action.transcodingProfile.id : null,
        transcodingOutputIds: action.transcodingOutputs && action.transcodingOutputs.items
          ? action.transcodingOutputs.items.map((i) => (i.transcodingOutput ? i.transcodingOutput.id : i.transcodingOutputId))
          : [],
        version: action.version,
        variables: { outputGroups: savedOutputGroups },
      };
      this.showTranscodeEditDialog = true;
    },

    async saveTranscodeAction() {
      this.loading = true;
      const filteredGroups = {};
      for (const [key, val] of Object.entries(this.transcodeEditForm.variables.outputGroups || {})) {
        if (val.destinationA || val.destinationB || val.nameModifier) {
          filteredGroups[key] = {};
          if (val.destinationA) filteredGroups[key].destinationA = val.destinationA;
          if (val.destinationB) filteredGroups[key].destinationB = val.destinationB;
          if (val.nameModifier) filteredGroups[key].nameModifier = val.nameModifier;
        }
      }
      const config = JSON.stringify({ variables: { outputGroups: filteredGroups } });
      const input = {
        id: this.transcodeEditForm.id,
        expectedVersion: this.transcodeEditForm.version,
        transcodingProfileId: this.transcodeEditForm.transcodingProfileId,
        transcodingOutputIds: this.transcodeEditForm.transcodingOutputIds,
        config,
        lastUpdatedById: this.userId,
        claimsCanAccess: this.selectedEvent.claimsCanAccess,
        claimsCanEdit: this.selectedEvent.claimsCanEdit
      };

      try {
        const result = await this.patchEventAction(input);
        if (result && result.success) {
          // Update the action version and IDs in the local state
          const index = this.selectedEvent.actions.items.findIndex(a => a.id === this.transcodeEditForm.id);
          if (index !== -1) {
            const updatedProfile = this.accountTranscodeProfiles.find(p => p.id === this.transcodeEditForm.transcodingProfileId);
            const updatedOutputs = this.transcodeEditForm.transcodingOutputIds.map(outId => {
              const out = this.accountTranscodeOutputs.find(o => o.id === outId);
              return { transcodingOutput: { id: outId, name: out ? out.name : outId } };
            });

            this.$set(this.selectedEvent.actions.items, index, {
              ...this.selectedEvent.actions.items[index],
              version: result.version || this.transcodeEditForm.version + 1,
              config,
              transcodingProfileId: this.transcodeEditForm.transcodingProfileId,
              transcodingProfile: updatedProfile ? { ...updatedProfile } : null,
              transcodingOutputIds: [...this.transcodeEditForm.transcodingOutputIds],
              transcodingOutputs: { items: updatedOutputs }
            });
          }

          this.$message.success('Transcoding action updated');
          this.showTranscodeEditDialog = false;
          // Refresh event data to ensure full consistency
          this.getEvent(this.selectedEvent.id);
        } else {
          this.$message.error(result.message || 'Failed to update transcoding action');
        }
      } catch (err) {
        console.error('Failed to update transcode action', err);
        this.$message.error('An error occurred while saving');
      } finally {
        this.loading = false;
      }
    },

    async deleteTranscodeAction(action) {
      const confirmation = await this.$confirm('Are you sure you want to remove this transcoding action?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
      });

      if (confirmation !== 'confirm') return;

      this.loading = true;
      const input = {
        eventActionId: action.id,
        expectedVersion: action.version,
        eventId: this.selectedEvent.id,
        lastUpdatedById: this.userId,
      };

      try {
        const result = await this.removeEventActionAndDependencies(input);
        if (result && result.success) {
          this.$message.success('Transcoding action removed');
          this.getEvent(this.selectedEvent.id);
        } else {
          this.$message.error(result.message || 'Failed to remove transcoding action');
        }
      } catch (err) {
        console.error('Failed to remove transcode action', err);
        this.$message.error('An error occurred while deleting');
      } finally {
        this.loading = false;
      }
    },

    setOutputGroupVar(outputName, field, value) {
      const groups = this.transcodeEditForm.variables.outputGroups;
      if (!groups[outputName]) {
        this.$set(groups, outputName, { destinationA: '', destinationB: '', nameModifier: '' });
      }
      this.$set(groups[outputName], field, value);
    },

    duplicateBooking(booking) {
      this.setBookingClone(booking);
      this.setShowCreateEventDialog(true);
    },

    clearSelectedEvent() {
      this.setActiveEvent(null);
      this.selectedEvent = null;
    },

    edit(property, value) {
      this.showPopups[property] = true;
      this.editBackupValue = value;
    },

    cancel(property) {
      this.editBackupValue = null;
      this.showPopups[property] = false;
    },

    parseEventConfig(configValue) {
      if (!configValue) return {};
      if (typeof configValue === 'object') return { ...configValue };
      if (typeof configValue !== 'string') return {};
      try {
        return JSON.parse(configValue);
      } catch (error) {
        console.warn('Failed to parse event config', error);
        return {};
      }
    },

    editInputProfileOverride() {
      this.inputProfileOverrideDraft = JSON.stringify(
        this.inputProfileOverride || DEFAULT_INPUT_PROFILE_CONFIG,
      );
    },

    async saveInputProfileOverride() {
      let parsed;
      try {
        parsed = JSON.parse(this.inputProfileOverrideDraft);
      } catch (error) {
        this.$message.error('Invalid input profile config');
        return;
      }
      await this.save('config', JSON.stringify({
        ...this.eventConfig,
        inputProfileOverride: parsed,
      }));
      this.inputProfileOverrideDraft = null;
    },

    async clearInputProfileOverride() {
      const { inputProfileOverride, ...rest } = this.eventConfig;
      await this.save('config', JSON.stringify(rest));
    },

    async setLiveMonitoringAuto(value) {
      const nextConfig = {
        ...this.eventConfig,
        liveMonitoring: value === true,
      };
      this.liveMonitoringLoading = true;
      try {
        await this.save('config', JSON.stringify(nextConfig));
      } finally {
        this.liveMonitoringLoading = false;
      }
    },

    async refreshSelectedEvent() {
      if (!this.selectedEvent || !this.selectedEvent.id) return;
      const event = await this.getEvent(this.selectedEvent.id);
      if (event && !event.error) this.processEvent(event);
    },

    async runLiveMonitoringCommand(action) {
      if (!this.selectedEvent || !this.selectedEvent.id) {
        this.$message.error('Event ID is required');
        return;
      }
      this.liveMonitoringLoading = true;
      try {
        const result = await action(this.selectedEvent.id);
        if (result && !result.error && result.success !== false) {
          await this.refreshSelectedEvent();
        }
      } finally {
        this.liveMonitoringLoading = false;
      }
    },

    async startLiveMonitoringNow() {
      await this.runLiveMonitoringCommand(this.eventStartLiveMonitoring);
    },

    async stopLiveMonitoringNow() {
      await this.runLiveMonitoringCommand(this.eventStopLiveMonitoring);
    },

    async save(property, value) {
      const newEvent = this.getEventObjForUpdate(this.selectedEvent);
      newEvent[property] = value;
      if (property === 'fixture') {
        newEvent.name = value;
      }
      console.log('xxxxxx', newEvent, property, value);

      if (property === 'status') {
        await this.saveStatus(value, this.selectedEvent);
        this.editBackupValue = null;
        this.showPopups[`${property}Popup`] = false;
        return;
      }

      const result = await this.updateEvent(newEvent);
      this.event = result;
      if (property !== 'inputDetails' && property !== 'fixture' && property !== 'description') {
        this.editBackupValue = null;
        this.showPopups[`${property}Popup`] = false;
        return;
      }
      console.log('shouldChangeToClientConfirmed: upload event', this.shouldChangeToClientConfirmed);
      if (this.shouldChangeToClientConfirmed) await this.save('status', 'CLIENT_CONFIRMED')

      this.editBackupValue = null;
      this.showPopups[`${property}Popup`] = false;
    },

    async saveStatus(status, event) {
      const accountId = this.eventAccount.code;
      const clientId = this.eventClient.code;
      const input = {
        clientId: clientId,
        accountId: accountId,
        expectedVersion: event.version,
        status: status,
        eventId: event.id,
      };

      const result = await this.eventChangeStatus(input);
      console.log('status update => ', result);
    },

    async toggleFRC(property, value) {
      const newEvent = this.getEventObjForUpdate(this.selectedEvent);
      newEvent[property] = value;
      const input = this.defaultInputPictureFormat.id;
      const output = this.defaultOutputPictureFormat.id;
      newEvent.eventInputFrcInputFormatId = input;
      newEvent.eventInputFrcOututFormatId = output;

      const result = await this.updateEvent(newEvent);
      this.event = result;
      this.editBackupValue = null;
      this.showPopups[`${property}Popup`] = false;
    },

    async updateDownlinkConfig() {
      const newEvent = this.getEventObjForUpdate(this.selectedEvent);
      this.downlinkConfigForm.claimsCanEdit = newEvent.claimsCanEdit;
      this.downlinkConfigForm.claimsCanAccess = newEvent.claimsCanAccess;
      this.downlinkConfigForm.version = 1;
      this.downlinkConfigForm.inputDownlinkConfigLastUpdatedById = this.userId;

      const downlinkConfigId = await this.createDownlinkConfig(this.downlinkConfigForm);
      newEvent.eventInputDownlinkConfigId = downlinkConfigId.id;
      const result = await this.updateEvent(newEvent);
      this.event = result;
      // if (this.appSettings.symbolRate.indexOf(this.downlinkConfigForm.symbolRate) === -1) {
      //   this.appSettings.symbolRate.push(this.downlinkConfigForm.symbolRate);
      //   console.log(this.appSettings.symbolRate);
      //   this.updateAppSetting({ id: 'symbolRate', key: 'symbolRate', value: this.appSettings.symbolRate.join(',') });
      // }
      this.editBackupValue = null;
      this.showPopups.downlinkConfigPopup = false;
      console.log('shouldChangeToClientConfirmed: upload event', this.shouldChangeToClientConfirmed);
      if (this.shouldChangeToClientConfirmed) await this.save('status', 'CLIENT_CONFIRMED')
    },

    async cancelWithComment() {
      const result = await this.$prompt('Please provide comment/reason for cancellation', 'Canceling booking', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
      });

      const isConfirmed = result.action === 'confirm';
      if (!isConfirmed) return;

      const newEvent = this.getEventObjForUpdate(this.selectedEvent);
      newEvent.cancellationMsg = result.value;
      console.log('test cancelWithComment', result, newEvent);
      await this.updateEvent(newEvent);
      await this.saveStatus('CANCELLED', this.selectedEvent);
    },

    editAudioChannel(mapping, index) {
      this.tempAudioMapping = {
        ...mapping,
      };
      this.audoMappingPopups[index] = true;
    },

    cancelAudioEdit(index) {
      this.clearAudioPopup();
      this.audoMappingPopups[index] = false;
    },

    async saveAudioMapping(index) {
      const newMapping = {
        ...this.tempAudioMapping,
        eventAudioChannelLastUpdatedById: this.userId,
        // eventAudioMappingId: this.selectedEvent.id,
        claimsCanAccess: this.claimsCanAccess,
        claimsCanEdit: this.claimsCanEdit,
      };

      await this.updateEventAudioChannel(newMapping);
      this.clearAudioPopup();
      this.audoMappingPopups[index] = false;
      this.$forceUpdate();
    },

    clearAudioPopup() {
      this.tempAudioMapping = {
        channelNo: 0,
        nameFieldL: '',
        nameFieldR: '',
        active: false,
        stereo: true,
      };
    },

    async rescheduleBooking() {
      const {
        lineupTime,
        lineupDate,
        startTime,
        startDate,
        endTime,
        endDate,
        eventId,
        expectedVersion,
        accountId,
        clientId,
      } = this.rescheduleForm;
      const {
        headTimeMin,
        tailTimeMin,
      } = this.selectedEvent;

      const payload = {
        lineupTime: moment.utc(`${lineupDate} ${lineupTime}`).format(),
        startTime: moment.utc(`${startDate} ${startTime}`).format(),
        endTime: moment.utc(`${endDate} ${endTime}`).format(),
        headTimeMin,
        tailTimeMin,
        eventId,
        expectedVersion,
        accountId,
        clientId,
        serviceStartTimeOffsetMin: this.serviceStartTimeOffsetMin,
      };
      const result = await this.rescheduleEvent(payload);
      const hasErrors = result.error;
      console.log('result reschedule 1', result);
      if (hasErrors) return;
      this.rescheduleEventDialog = false;
      console.log('result reschedule', result);
      Vue.set(this, 'selectedEvent', result);
      this.fixture = result.fixture;
      this.sport = result.sport;
      this.property = result.property;
      this.description = result.description;
      this.lineupTime = result.lineupTime;
      this.inputAudioPid = result.inputAudioPid;
      this.inputVideoPid = result.inputVideoPid;

      this.$forceUpdate();
    },

    async changeInput(input) {
      await this.applyInputChange({ newInputId: input.id });
    },

    async changeInputProfile(profile) {
      await this.applyInputChange({ newInputProfileId: profile.id });
    },

    async applyInputChange(change) {
      const data = {
        eventId: this.selectedEvent.id,
        accountId: this.eventAccount.code,
        clientId: this.eventClient.code,
        expectedVersion: this.selectedEvent.version,
        ...change,
      };

      const result = await this.eventInputChange(data);
      if (!result || !result.success) return result;
      console.log('shouldChangeToClientConfirmed: upload event', this.shouldChangeToClientConfirmed);
      if (this.shouldChangeToClientConfirmed) await this.save('status', 'CLIENT_CONFIRMED')
      this.showPopups.inputPopup = false;
      return result;
    },

    async changeCommetnaryUser(user) {
      const newEvent = this.getEventObjForUpdate(this.selectedEvent);
      newEvent.eventCommentaryUserId = user.id;
      await this.updateEvent(newEvent);
      this.editBackupValue = null;

      this.showPopups.commentaryUserPopup = false;
    },

    // inputs only - no profile override field, profiles go through changeInputProfile
    async ovrrideInput(input) {
      this.loading = true;
      this.showPopups.ovrrideInputPopup = false;
      await this.applyInputChange({ newInputOverrideId: input.id });
      this.editBackupValue = null;
      this.loading = false;
    },

    async addOutputs(shouldCopyStreamKeys) {
      this.loading = true;
      const data = {
        eventId: this.selectedEvent.id,
        outputProfileId: this.outputProfileId,
        accountId: this.eventAccount.code,
        clientId: this.eventClient.code,
        claimsCanAccess: this.selectedEvent.claimsCanAccess,
        claimsCanEdit: this.selectedEvent.claimsCanEdit,
      };
      const result = await this.eventOutputProfileChange(data);
      if (result.error) {
        let msg = 'Oops something went wrong. Can\'t add output';
        if (result.message && Array.isArray(result.message)) {
          const timeoutError = result.message.find((e) => e.errorType === 'Lambda:ExecutionTimeoutException');
          if (timeoutError) {
            msg = 'Operation timed out. The event has been reloaded.';
          }
        }
        this.$message.error(msg);
        this.loading = false;
        return;
      }
      this.event = result;
      console.log('%c OUTPUT UPATE', 'color:lime', result);
      this.loading = false;
      if (!shouldCopyStreamKeys) {
        this.shouldCopyStreamKeys = false;
        this.addOutputDialog = false;
        return;
      }

      let actions = result.actions.items || [];
      actions = actions
        .map((action) => {
          const actionOutputMap = this.selectedEvent.outputs.items
            .find((el) => action.assignedOutput.id === el.output.id);

          return {
            ...action,
            actionOutputMap,
          };
        });
      const ottTargets = actions
        .filter((action) => {
          return action.assignedOutput.outputType === 'OTT';
        })
      console.log('%c OUTPUT UPATE', 'color:lime', ottTargets, result);
      let event = this.event;
      await this.asyncForEach(ottTargets, async (target, index) => {
        const streamKey = this.savedStreamKeys[index].streamKey || this.savedStreamKeys[0].streamKey;
        const model = {
          eventId: this.selectedEvent.id,
          streamTargetId: target.configWowza.targets.items[0].id,
          streamKey: streamKey,
          name: target.configWowza.targets.items[0].target,
        };
        event = await this.setStreamKey(model);
      });
      this.processEvent(event);
      this.shouldCopyStreamKeys = false;
      this.addOutputDialog = false;
      // this.shouldCopyStreamKeys = false;
      // const model = {
      //   eventId: this.selectedEvent.id,
      //   streamTargetId: target.configWowza.targets.items[0].id,
      //  streamKey: target.configWowza.targets.items[0].streamKey,
      //  name: target.configWowza.targets.items[0].target,
      // };
      // await this.setStreamKey(model);
    },

    openStreamRouterEdit(target) {
      const output = target.assignedOutput;
      const url = output.url || '';
      // Parse SRT URL if present
      // Example: srt://host:port?mode=caller&latency=200

      let destination = '';
      let latency = 200;
      let passphrase = '';
      let streamId = '';

      if (url.startsWith('srt://')) {
        try {
          const urlObj = new URL(url.replace('srt://', 'http://')); // Hack to parse
          destination = urlObj.hostname + (urlObj.port ? ':' + urlObj.port : '');
          const params = new URLSearchParams(urlObj.search);
          if (params.has('latency')) latency = parseInt(params.get('latency'), 10);
          if (params.has('passphrase')) passphrase = params.get('passphrase');
          if (params.has('streamid')) streamId = params.get('streamid');
        } catch (e) {
          console.error('Failed to parse SRT URL', e);
          destination = url.replace('srt://', '');
        }
      } else {
        destination = url;
      }

      this.streamRouterForm = {
        destination,
        latency: latency || 200,
        passphrase,
        streamId,
        targetId: output.id,
      };
      this.streamRouterEditDialog = true;
    },

    async saveStreamRouter() {
      this.loading = true;
      try {
        let newUrl = `srt://${this.streamRouterForm.destination}?mode=caller&latency=${this.streamRouterForm.latency}`;
        if (this.streamRouterForm.passphrase) {
          newUrl += `&passphrase=${this.streamRouterForm.passphrase}`;
        }
        if (this.streamRouterForm.streamId) {
          newUrl += `&streamid=${this.streamRouterForm.streamId}`;
        }

        await client.graphql({
          query: updateOutput,
          variables: {
            input: {
              id: this.streamRouterForm.targetId,
              url: newUrl,
            },
          },
        });

        this.$message.success('Stream Router updated successfully.');
        this.streamRouterEditDialog = false;
        // Refresh event or local list
        this.getEvent(this.selectedEvent.id).then((event) => {
            this.selectedEvent = event;
        });

      } catch (err) {
        console.error('Failed to update Stream Router', err);
        this.$message.error('Failed to update Stream Router');
      } finally {
        this.loading = false;
      }
    },

    openWowzaEdit(target) {
      const config = target.configWowza.targets.items[0];
      // Try to parse target field if it contains host/port/streamName
      // Expecting standard format or JSON?
      // Assumption: The user wants to set these fields which will be stored somewhere.
      // Based on limited info, I will try to parse 'target' if it looks like rtmp://
      // But user said: "W wowzie będzie tylko obsługiwany rtmp z paramertami destination app name, destination host, port i stream name"

      // Let's assume 'target' field stores: rtmp://host:port/streamName
      // and 'application' stores the App Name.

      let host = '';
      let port = 1935;
      let streamName = '';

      if (config.target && config.target.startsWith('rtmp://')) {
          try {
              const urlObj = new URL(config.target.replace('rtmp://', 'http://'));
              host = urlObj.hostname;
              port = urlObj.port ? parseInt(urlObj.port, 10) : 1935;
              streamName = urlObj.pathname.substring(1); // remove leading slash
          } catch(e) {
              console.error('Failed to parse RTMP target', e);
          }
      } else {
          // If not a URL, maybe it's just a name? But we want to allow editing host/port.
          // Fallback to empty
      }

      this.wowzaForm = {
        application: config.application || '',
        host,
        port,
        streamName,
        targetId: config.id,
        version: config.version,
        origTarget: config.target // Keep original to compare/restore or just overwrite
      };
      this.wowzaEditDialog = true;
    },

    async saveWowza() {
      this.loading = true;
      try {
        // Construct new target string: rtmp://host:port/streamName
        const newTarget = `rtmp://${this.wowzaForm.host}:${this.wowzaForm.port}/${this.wowzaForm.streamName}`;

        await client.graphql({
          query: updateWowzaTarget,
          variables: {
            input: {
              id: this.wowzaForm.targetId,
              application: this.wowzaForm.application,
              target: newTarget,
              expectedVersion: this.wowzaForm.version
            },
          },
        });

        this.$message.success('Wowza Target updated successfully.');
        this.wowzaEditDialog = false;
         // Refresh event or local list
        this.getEvent(this.selectedEvent.id).then((event) => {
             this.selectedEvent = event;
        });
      } catch (err) {
        console.error('Failed to update Wowza Target', err);
        this.$message.error('Failed to update Wowza Target: ' + (err.message || 'Unknown error'));
      } finally {
        this.loading = false;
      }
    },

    async deleteOutput(output) {
      const [outputMapping] = this.selectedEvent.outputs.items
        .filter((item) => item.output.id === output.id);
      const doesMappingExist = !!outputMapping;

      if (!doesMappingExist) {
        this.$message.error(
          { message: 'Can\'t delete output. Output mapping does not exist.' },
        );
        return;
      }
      const data = {
        eventId: this.selectedEvent.id,
        input: {
          eventOutputMapId: outputMapping.id,
          accountId: this.eventAccount.code,
          clientId: this.eventClient.code,
          outputName: outputMapping.output.name,
        },
      };

      const result = await this.eventOutputRemove(data);
      if (result && result.error) {
        let msg = 'Oops something went wrong. Can\'t delete output';
        if (result.message && Array.isArray(result.message)) {
          const timeoutError = result.message.find((e) => e.errorType === 'Lambda:ExecutionTimeoutException');
          if (timeoutError) {
            msg = 'Operation timed out. The event has been reloaded.';
          }
        }
        this.$message.error(msg);
      }
    },

    getUpdatedTimes(lineupTime, startTime, endTime, headTimeMin, tailTimeMin) {
      const startDate = this.selectedEvent.startTime.split('T')[0];
      const endDate = this.selectedEvent.endTime.split('T')[0];
      const lineupDate = this.selectedEvent.lineupTime.split('T')[0];

      return {
        ...this.rescheduleForm,
        lineupTime: moment.utc(`${lineupDate} ${lineupTime}`)
          .format(),
        startTime: moment.utc(`${startDate} ${startTime}`)
          .format(),
        endTime: moment.utc(`${endDate} ${endTime}`)
          .format(),
        headTimeMin,
        tailTimeMin,
      };
    },

    async setStatus(status) {
      const confirmation = await this.$confirm('Are you sure you want to change status of the event?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
      });

      const isConfirmed = confirmation === 'confirm';
      if (!isConfirmed) return;
      this.save('status', status);
    },

    async setAsPending() {
      const confirmation = await this.$confirm('Are you sure you want to set booking to pending?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
      });

      const isConfirmed = confirmation === 'confirm';
      if (!isConfirmed) return;
      this.save('status', 'PENDING');
    },

    async confirmPostpone() {
      const confirmation = await this.$confirm('Are you sure you want to postpone booking?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
      });

      const isConfirmed = confirmation === 'confirm';
      if (!isConfirmed) return;
      this.save('status', 'POSTPONED');
    },

    async confirmDeleteEventPermanently() {
      const confirmation = await this.$confirm('This will permanently delete booking. Are you sure?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
      });

      const isConfirmed = confirmation === 'confirm';
      if (!isConfirmed) return;
      this.deleteEvent(this.selectedEvent);
      this.clearSelectedEvent();
    },

    async confirmDelete() {
      const confirmation = await this.$confirm('Are you sure you want to cancel booking?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
      });

      const isConfirmed = confirmation === 'confirm';
      if (!isConfirmed) return;

      if (!this.isBeforeServiceTimeStart || this.eventStatus === 'LIVE') {
        this.save('status', 'LATE_CANCELLED');
        return;
      }
      this.save('status', 'CANCELLED');
    },

    async confirmConfirmation() {
      const confirmation = await this.$confirm('Once booking is confirmed MediaAtmos will confirm resources required and once done the status will change to "Resource confirmed"', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
      });

      const isConfirmed = confirmation === 'confirm';
      if (!isConfirmed) return;
      this.save('status', 'CLIENT_CONFIRMED');
    },

    async sysAdminConfirmConfirmation() {
      const confirmation = await this.$confirm('Are you sure you want to confirm booking?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
      });

      const isConfirmed = confirmation === 'confirm';
      if (!isConfirmed) return;
      this.save('status', 'CONFIRMED');
    },

    async startStream(target, event) {
      const confirmation = await this.$confirm('Are you sure you want to start the stream?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
      });

      const isConfirmed = confirmation === 'confirm';
      if (!isConfirmed) return;

      this.routerStartTarget({ eventId: this.selectedEvent.id, targetId: target.id });
    },

    async stopStream(target, event) {
      const confirmation = await this.$confirm('Are you sure you want to stop the stream?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
      });

      const isConfirmed = confirmation === 'confirm';
      if (!isConfirmed) return;

      this.routerStopTarget({ eventId: this.selectedEvent.id, targetId: target.id });
    },

    async startEventNow() {
      try {
        // Safety check
        if (!this.selectedEvent?.id) {
          this.$message.error('Event ID is required');
          return;
        }

        const confirmation = await this.$confirm('Are you sure you want to start booking now?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning',
        });

        const isConfirmed = confirmation === 'confirm';
        if (!isConfirmed) return;

        this.eventManualStart(this.selectedEvent.id);

        // Only handle additional logic if operation was successful
        if (!result?.error) {
          // Refresh event data
          this.processEvent(this.selectedEvent);
        }
      } catch (error) {
        console.error('startEventNow error:', error);
        // Store already handled the error message, just log for debugging
      }
    },

    async stopEventNow() {
      try {
        // Safety check
        if (!this.selectedEvent?.id) {
          this.$message.error('Event ID is required');
          return;
        }

        const h = this.$createElement;
        const stopOptions = { forceStop: false };

        const confirmation = await this.$confirm(
          h('div', null, [
            h('p', null, 'Are you sure you want to stop booking now?'),
            h('el-checkbox', {
              on: {
                change: (val) => { stopOptions.forceStop = val; },
              },
            }, 'Force stop'),
          ]),
          'Warning',
          {
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancel',
            type: 'warning',
          }
        );

        const isConfirmed = confirmation === 'confirm';
        if (!isConfirmed) return;

        // Use new router API - store handles success/error messages
        const result = await this.routerStopEvent({
          eventId: this.selectedEvent.id,
          forceStop: stopOptions.forceStop,
        });

        // Only handle additional logic if operation was successful
        if (!result?.error) {
          // Refresh event data
          this.processEvent(this.selectedEvent);
        }
      } catch (error) {
        console.error('stopEventNow error:', error);
        // Store already handled the error message, just log for debugging
      }
    },

    async restartEventNow() {
      try {
        // Safety check
        if (!this.selectedEvent?.id) {
          this.$message.error('Event ID is required');
          return;
        }

        const confirmation = await this.$confirm('Are you sure you want to restart the event?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning',
        });

        const isConfirmed = confirmation === 'confirm';
        if (!isConfirmed) return;

        // Use new router API - store handles success/error messages
        const result = await this.routerRestartEvent({ eventId: this.selectedEvent.id });

        // Only handle additional logic if operation was successful
        if (!result?.error) {
          // Refresh event data
          this.processEvent(this.selectedEvent);
        }
      } catch (error) {
        console.error('restartEventNow error:', error);
        // Store already handled the error message, just log for debugging
      }
    },

    async stopEventOutput() {
      try {
        // Safety check
        if (!this.selectedEvent?.id) {
          this.$message.error('Event ID is required');
          return;
        }

        const confirmation = await this.$confirm('Are you sure you want to stop event output?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning',
        });

        const isConfirmed = confirmation === 'confirm';
        if (!isConfirmed) return;

        // Use new router API - store handles success/error messages
        const result = await this.routerStopOutput({ eventId: this.selectedEvent.id });

        // Only handle additional logic if operation was successful
        if (!result?.error) {
          // Refresh event data
          this.processEvent(this.selectedEvent);
        }
      } catch (error) {
        console.error('stopEventOutput error:', error);
        // Store already handled the error message, just log for debugging
      }
    },

    async addAudioChannel(form, object, event) {
      const doCreate = !!event.id;
      const formObject = this.$refs[form];
      const isValid = await formObject.validate();
      if (!isValid) return null;
      const audioMappingForm = {
        active: this.audioMappingForm.active,
        channelNo: this.audioMappingForm.channelNo,
        description: this.audioMappingForm.description,
        stereo: this.audioMappingForm.stereo,
      };
      console.log('this.audioMappingForm.stereo', this.audioMappingForm.stereo);

      // if existing event is attached create mapping
      if (!doCreate) {
        this.audioMappingForm.channelNo = this.audioMappingForm.channelNo + 1;
        this.audioMappingForm.description = '';
        object.push(audioMappingForm);
      }

      const newMapping = {
        ...audioMappingForm,
        eventAudioChannelLastUpdatedById: this.userId,
        eventAudioChannelEventId: event.id,
        claimsCanAccess: this.audioClaimsCanAccess,
        claimsCanEdit: this.audioClaimsCanEdit,
      };

      await this.createEventAudioChannel(newMapping);
      this.$forceUpdate();
      return false;
    },

    async deleteAudioChannel(id, event) {
      const needsUpdate = !!event.id;
      if (!needsUpdate) {
        // object.splice(index, 1);
        return false;
      }
      await this.deleteEventAudioChannel(id);
      this.$forceUpdate();
      return false;
    },

    async addTime(event, type, time) {
      const parsedTime = Number(time);
      if (!Number.isFinite(parsedTime) || parsedTime === 0) return;

      const headTime = type === 'head' ? event.headTimeMin + parsedTime : event.headTimeMin;
      const tailTime = type === 'tail' ? event.tailTimeMin + parsedTime : event.tailTimeMin;

      if (type === 'tail' && parsedTime < 0) {
        if (tailTime < 0) {
          this.$message.error('Cannot remove more time than currently added.');
          return;
        }

        const updatedEndTime = moment(event.endTime).add(parsedTime, 'minutes');
        if (!updatedEndTime.isAfter(moment.utc())) {
          this.$message.error('Cannot set booking end time to now or in the past.');
          return;
        }
      }

      const startTime = type === 'head' ? moment(event.startTime).subtract(parsedTime, 'minutes') : event.startTime;
      const endTime = type === 'tail' ? moment(event.endTime).add(parsedTime, 'minutes') : event.endTime;
      const newTimes = {
        ...this.rescheduleForm,
        lineupTime: event.lineupTime,
        startTime,
        endTime,
        headTimeMin: headTime,
        tailTimeMin: tailTime,
        serviceStartTimeOffsetMin: this.serviceStartTimeOffsetMin,
      };

      delete newTimes.endDate;
      delete newTimes.startDate;
      delete newTimes.lineupDate;
      this.loading = true;
      try {
        const result = await this.rescheduleEvent(newTimes);
        const hasErrors = result.error;
        console.log('result reschedule 1', result);
        if (hasErrors) return;
        if (result?.skipped) return;
        this.rescheduleEventDialog = false;
        console.log('result reschedule', result);
        Vue.set(this, 'selectedEvent', result);
        this.fixture = result.fixture;
        this.sport = result.sport;
        this.property = result.property;
        this.description = result.description;
        this.lineupTime = result.lineupTime;
        this.inputAudioPid = result.inputAudioPid;
        this.inputVideoPid = result.inputVideoPid;

        this.$forceUpdate();
        console.log('event updated', event)
        this.$forceUpdate();
      } finally {
        this.loading = false;
      }
    },

    async openAddTime(event, type, mode = 'add') {
      try {
        const isRemoveMode = mode === 'remove';
        const result = await this.$prompt(
          'Please input time in minutes',
          isRemoveMode ? 'Remove time' : 'Extend time',
          {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          inputPattern: /^[0-9]+$/,
          inputErrorMessage: 'Invalid value',
          },
        );

        const { value } = result;
        const minutes = parseInt(value, 10);
        if (!Number.isFinite(minutes) || minutes <= 0) {
          this.$message.error('Please provide a positive number of minutes.');
          return;
        }
        const modifier = isRemoveMode ? -1 : 1;
        await this.addTime(event, type, minutes * modifier);
      } catch (error) {
        if (error === 'cancel') return;
        this.$message.error('Something went wrong!');
      }
    },

    async updateStreamKey(target) {
      try {
        // Safety checks
        if (!this.selectedEvent?.id) {
          this.$message.error('Event ID is required');
          return false;
        }
        if (!target?.streamTargetId && !target?.id) {
          this.$message.error('Target ID is required');
          return false;
        }
        if (!target?.streamKey) {
          this.$message.error('Stream key is required');
          return false;
        }

        this.loading = true;

        // Use new router API
        const result = await this.routerSetStreamKey({
          eventId: this.selectedEvent.id,
          targetId: target.streamTargetId || target.id,
          streamKey: target.streamKey,
        });

        if (result?.error) {
          console.error('Router set stream key error:', result.message);
          this.$message.error('Failed to update stream key');
          return false;
        }

        this.$message.success('Stream key updated successfully');
        // Refresh event data
        this.processEvent(this.selectedEvent);
        this.$forceUpdate();
        this.setStreamKeyDialog = false;
        return true;
      } catch (error) {
        console.error('updateStreamKey error:', error);
        this.$message.error('Failed to update stream key: ' + (error.message || 'Unknown error'));
        return false;
      } finally {
        this.loading = false;
      }
    },

    async updateTranscoderProfile(target) {
      const targets = this.sortedActions.filter((el) => {
        return el.assignedOutput.outputType === 'OTT';
      });

      await this.asyncForEach(targets, async (tr, index) => {
        const [wowzaTarget] = tr.configWowza.targets.items;
        const profile = target.sysAdminOption || target.transcoderProfile;
        const payload = {
          id: wowzaTarget.id,
          transcoderProfile: profile,
          expectedVersion: wowzaTarget.version,
          claimsCanEdit: wowzaTarget.claimsCanEdit,
          claimsCanAccess: wowzaTarget.claimsCanAccess,
        };
        console.log('transcoder Profile', targets, tr, target);
        await this.updateWowzaTarget({payload, id: this.selectedEvent.id});
      });

      console.log('transcoder Profile', targets, this.sortedActions, target);
      this.$forceUpdate();
      this.setTranscoderDialog = false;
      return false;
    },
    async asyncForEach(array, callback) {
      for (let index = 0; index < array.length; index += 1) {
        await callback(array[index], index, array); // eslint-disable-line
      }
    },

    async setOverrideOutputMap(target) {
      console.log('.......', target);
      const model = {
        eventId: target.eventId,
        override: target.override,
        id: target.id,
      };
      await this.setEventOutputMapOverride(model);
      this.$forceUpdate();
      this.setOverrideOutputDialog = false;
      return false;
    },

    async updateAutostart(model) {
      await this.updateWowzaConfig({ input: model, eventId: this.selectedEvent.id });
      this.$forceUpdate();
      this.setAutostartDialog = false;
      return false;
    },

    editTranscoderProfile(target) {
      this.tempTarget = {
        eventId: this.selectedEvent.id,
        streamTargetId: target.configWowza.targets.items[0].id,
        transcoderProfile: target.configWowza.targets.items[0].transcoderProfile,
        name: target.configWowza.targets.items[0].target,
        sysAdminOption: null,
        target,
      };
      this.setTranscoderDialog = true;
    },

    editStreamKey(target) {
      this.tempTarget = {
        eventId: this.selectedEvent.id,
        streamTargetId: target.configWowza.targets.items[0].id,
        streamKey: target.configWowza.targets.items[0].streamKey,
        name: target.configWowza.targets.items[0].target,
      };
      this.setStreamKeyDialog = true;
    },

    editOutputOverride(target) {
      console.log('%ceditOutputOverride', 'color:blue', target);
      this.tempTarget = {
        eventId: this.selectedEvent.id,
        id: target.actionOutputMap.id,
        override: target.actionOutputMap.outputOttApplicationOverride,
        name: target.configWowza.targets.items[0].target,
      };
      this.setOverrideOutputDialog = true;
    },

    setAutostart(action) {
      const { configWowza } = action;
      this.tempWowzaConfig = {
        id: configWowza.id,
        claimsCanEdit: configWowza.claimsCanEdit,
        claimsCanAccess: configWowza.claimsCanAccess,
        autostart: configWowza.autostart,
        autostartOffsetMin: configWowza.autostartOffsetMin,
        expectedVersion: configWowza.version,
      };
      this.setAutostartDialog = true;
    },

    getEventObjForUpdate(event) {
      return {
        bugRequired: event.bugRequired,
        claimsCanAccess: event.claimsCanAccess,
        claimsCanEdit: event.claimsCanEdit,
        description: event.description,
        endTime: event.endTime,
        eventAccountId: event.eventAccountId,
        eventCustomerId: event.eventCustomerId,
        eventInputId: event.eventInputId,
        expectedVersion: event.version,
        fixture: event.fixture,
        headTimeMin: event.headTimeMin,
        startType: event.startType,
        id: event.id,
        attachments: event.attachments,
        lineupTime: event.lineupTime,
        name: event.name,
        property: event.property,
        requestedBitrate: event.requestedBitrate,
        serviceEndTime: event.serviceEndTime,
        serviceStartTime: event.serviceStartTime,
        sport: event.sport,
        startTime: event.startTime,
        status: event.status,
        tailTimeMin: event.tailTimeMin,
        type: event.type,
        groupId: event.groupId,
        config: event.config,
        eventLastUpdatedById: this.userId,
      };
    },

    openReportDialog(event) {
      this.reportForm.eventId = event.id;
      this.reportForm.ntr = false;
      this.eventToReport = event.extendedProps;
      this.reportForm.description = '';
      this.reportEventDialog = true;

      this.reportForm.clientId = this.eventClient.code;
      this.reportForm.accountId = this.eventAccount.code;
      this.reportForm.claimsCanAccess = this.claimsCanAccess;
      this.reportForm.claimsCanEdit = this.claimsCanEdit;
    },

    async sendReport() {
      const result = await this.addEventReport(this.reportForm);
      if (!result.error) this.reportEventDialog = false;
    },

    async sendNothingToReport(event) {
      this.reportForm.eventId = event.id;
      this.reportForm.clientId = this.eventClient.code;
      this.reportForm.accountId = this.eventAccount.code;
      this.reportForm.ntr = true;
      this.reportForm.claimsCanAccess = this.claimsCanAccess;
      this.reportForm.claimsCanEdit = this.claimsCanEdit;
      delete this.reportForm.description;
      await this.addEventReport(this.reportForm);
    },
    transcodeDestinationUrls(action) {
      return getTranscodeDestinationUrls(action);
    },

    openHlsPlayer(url, name) {
      this.hlsPlayer = { visible: true, url, name };
    },

    async copyValue(text) {
      try {
        await navigator.clipboard.writeText(text);
      } catch (error) {
        const input = document.createElement('textarea');
        input.value = text;
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        document.body.removeChild(input);
      }
      this.$message.success('Copied to clipboard');
    },

    copyToClipboard(containerid) {
      const selection = window.getSelection();
      const range = document.createRange();
      range.selectNodeContents(document.getElementById(containerid));
      selection.removeAllRanges(); // Remove all ranges from the selection.
      selection.addRange(range);
      document.execCommand('Copy');
      this.$message.success('Copied to clipboard');
      this.showPopups.downlinkConfigPopup = false;
      this.cancel('downlinkConfigPopup', 'downlink');
      setTimeout(() => {
        this.showPopups.downlinkConfigPopup = false;
        this.$forceUpdate();
      }, 1);
    },

    // UPLOAD MEHTODS
    async downloadAttachment(attachment) {
      let key = '';
      let fileName = '';
      if (typeof attachment === 'string') {
          const clientId = this.eventClient.code;
          const accountId = this.eventAccount.code;
          key = `public/${clientId}/${accountId}/${attachment}`;
          fileName = attachment;
      } else {
          key = `public/${attachment.key}`;
          fileName = attachment.fileName;
      }

      const file = await this.signDownloadUrl(key);
      const link = document.createElement('a');
      link.download = fileName;
      link.href = file;
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    async handleUploadChange(file) {
      this.uploadFileLoading = true;
      const newEvent = this.getEventObjForUpdate(this.selectedEvent);
      this.fileToUpload = file;
      const name = file.name.substring(0, file.name.lastIndexOf('.'));
      const extension = file.name.substring(file.name.lastIndexOf('.'));
      const clientId = this.eventClient.code;
      const accountId = this.eventAccount.code;
      // const randomString = this.S4();
      const key = `${moment.utc().format('YYYYMMDD-HHmmss')}-${name}${extension}`;
      const fullKey = `${clientId}/${accountId}/${key}`;

      const operation = uploadData({
        key: fullKey,
        data: file.raw,
        options: {
          metadata: {
            account: accountId,
            client: clientId,
          },
        },
      });
      const result = await operation.result;
      this.uploadFileLoading = false;
      if (!result.key) {
        this.$message.error('Can\'t upload selected file. Please try again.');
        return;
      }

      // Handle Attachments Update (Migration to JSON List)
      let attachmentsList = [];
      const currentAttachmentsStr = newEvent.attachments || '';

      try {
        if (currentAttachmentsStr.trim().startsWith('[')) {
           attachmentsList = JSON.parse(currentAttachmentsStr);
        } else if (currentAttachmentsStr.trim().startsWith('{')) {
           const json = JSON.parse(currentAttachmentsStr);
           if (json.tagAttachments) {
             attachmentsList.push(...json.tagAttachments.map(a => ({ ...a, type: 'TAG' })));
           }
           if (json.regularAttachments) {
             attachmentsList.push(...json.regularAttachments.map(a => ({ ...a, type: 'REGULAR' })));
           }
        } else if (currentAttachmentsStr) {
           // Migrate legacy string
           const oldList = currentAttachmentsStr.split(',');
           attachmentsList = oldList.filter(f => f).map(f => ({
             fileName: f,
             key: `${clientId}/${accountId}/${f}`,
             type: 'REGULAR'
           }));
        }
      } catch (e) {
        console.error('Error parsing attachments', e);
      }

      // Add new attachment to regularAttachments list
      attachmentsList.push({
        fileName: key,
        key: fullKey,
        type: 'REGULAR'
      });

      newEvent.attachments = JSON.stringify(attachmentsList);

      const resultEvent = await this.updateEvent(newEvent);
      this.event = resultEvent;
      console.log('shouldChangeToClientConfirmed: upload event', this.shouldChangeToClientConfirmed);
      if (this.shouldChangeToClientConfirmed) await this.save('status', 'CLIENT_CONFIRMED')
    },
    async toggleAttachmentVisibility(attachment) {
      if (!this.selectedEvent || !this.selectedEvent.attachments) return;

      let attachmentsList = [];
      const currentAttachmentsStr = this.selectedEvent.attachments || '';

      try {
        if (currentAttachmentsStr.trim().startsWith('[')) {
           attachmentsList = JSON.parse(currentAttachmentsStr);
        } else if (currentAttachmentsStr.trim().startsWith('{')) {
           const json = JSON.parse(currentAttachmentsStr);
           if (json.tagAttachments) {
             attachmentsList.push(...json.tagAttachments.map(a => ({ ...a, type: 'TAG' })));
           }
           if (json.regularAttachments) {
             attachmentsList.push(...json.regularAttachments.map(a => ({ ...a, type: 'REGULAR' })));
           }
        } else if (currentAttachmentsStr) {
           // Old format
           const list = currentAttachmentsStr.split(',');
           const clientId = this.eventClient.code;
           const accountId = this.eventAccount.code;
           attachmentsList = list.filter(f => f).map(f => ({
             fileName: f,
             key: `${clientId}/${accountId}/${f}`,
             type: 'REGULAR'
           }));
        }
      } catch (e) {
        console.error('Error parsing attachments', e);
        return;
      }

      // Toggle visiblity
      const targetIndex = attachmentsList.findIndex(a => {
        // Match by key if available, otherwise by fileName being part of key or vice versa
        if (attachment.key && a.key) return a.key === attachment.key;
        return a.fileName === attachment.fileName;
      });

      if (targetIndex !== -1) {
        if (attachmentsList[targetIndex].hidden) {
          delete attachmentsList[targetIndex].hidden;
        } else {
          attachmentsList[targetIndex].hidden = true;
        }

        const newEvent = { ...this.selectedEvent };
        newEvent.attachments = JSON.stringify(attachmentsList);

        try {
          const resultEvent = await this.updateEvent(newEvent);
          this.event = resultEvent;
          this.$message.success(`Attachment ${attachmentsList[targetIndex].hidden ? 'hidden' : 'visible'}`);
        } catch (e) {
          this.$message.error('Failed to update attachment visibility');
          console.error(e);
        }
      }
    },
    async mapInputStream(source) {
      const payload = {
        claimsCanAccess: this.claimsCanAccess,
        claimsCanEdit: this.claimsCanEdit,
        eventInputStreamsMapEventId: this.selectedEvent.id,
        eventInputStreamsMapInputStreamId: source.id,
      };
      await this.mapEventInputStream(payload);
    },
    async mapOutputStream(dest) {
      const payload = {
        claimsCanAccess: this.claimsCanAccess,
        claimsCanEdit: this.claimsCanEdit,
        eventOutputStreamsMapEventId: this.selectedEvent.id,
        eventOutputStreamsMapOutputStreamId: dest.id,
      };
      await this.mapEventOutputStream(payload);
    },
    async unmapInputStream(source) {
      const payload = {
        id: source.id,
      };
      await this.unmapEventInputStream(payload);
    },
    async unmapOutputStream(dest) {
      const payload = {
        id: dest.id,
      };
      await this.unmapEventOutputStream(payload);
    },
    async asyncForEach(array, callback) {
      for (let index = 0; index < array.length; index += 1) {
        await callback(array[index], index, array); // eslint-disable-line
      }
    },
    copyCode(str) {
      const el = document.createElement('textarea');
      el.value = str;
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);

      this.$message.success('Copied to clipboard');
    },

    processEvent(event) {
      if (!event) return;
      const nowUtc = moment().utc();
      const item = event;
      const newItem = {
        ...event,
        id: item.id,
        start: item.startTime,
        startServiceTime: item.serviceStartTime,
        lineupTime: item.lineupTime,
        end: item.endTime,
        title: item.name,
        content: item.content,
        classNames: `${item.status} ${item.type}`,
        status: item.status,
        extendedProps: item,
        data: item,
        collapsed: true,
        isPastServiceTime: moment(nowUtc).isAfter(moment(item.serviceEndTime)),
      };

      if (item.customer) newItem.extendedProps.customerName = item.customer.name;
        const isOptus = 'otu' === newItem.extendedProps.customer.code && 'otu' === newItem.extendedProps.account.code;
        const isDownlink = newItem.extendedProps.input && newItem.extendedProps.input.type === 'DOWNLINK';
        console.log('CURRENT EVENTS CLIENT ACCOUNT', newItem.extendedProps.customer.code, newItem.extendedProps.account.code, isOptus, isDownlink);

        newItem.showRemap = isOptus && isDownlink;
        const inputSource = item.input || item.inputProfile;
        newItem.extendedProps.inputName = inputSource ? inputSource.name : '';
        newItem.extendedProps.inputOriginalName = newItem.extendedProps.inputName;
        newItem.extendedProps.inputName += item.inputDetails ? `<div class="muted">${item.inputDetails}</div>` : '';
        newItem.extendedProps.overrideInputName = item.inputOverride ? item.inputOverride.name : '';

        if (newItem.extendedProps.overrideInputName !== '' && this.isSysAdmin) {
          newItem.extendedProps.inputName += ` ${newItem.extendedProps.overrideInputName} (OVERRIDE)`;
        }
        if (newItem.extendedProps.input && newItem.extendedProps.input.type === 'DOWNLINK') {
          if (newItem.extendedProps.inputDownlinkConfig) {
            const {
              BISS,
              satelliteFrequency,
              satelliteName,
              symbolRate,
            } = newItem.extendedProps.inputDownlinkConfig;
            const configMissing = BISS && satelliteFrequency && satelliteName && symbolRate;
            if (!configMissing) newItem.extendedProps.inputName += '<div class="warning"> DOWNLINK CONFIG INCOMPLETE</div>';
          } else {
            newItem.extendedProps.inputName += '<div class="warning">DOWNLINK CONFIG MISSING</div>';
          }
          if (newItem.showRemap) newItem.extendedProps.inputName += '<span class="remap-tag">REMAP</span>';
        }
        newItem.extendedProps.audio = '';
        newItem.extendedProps.audioPDF = '';
        item.audioMapping.items.forEach((channel) => {
          newItem.extendedProps.audio
            += `${channel.channelNo} ${channel.description}
          `;
          newItem.extendedProps.audioPDF += `${channel.channelNo} ${channel.description} \r\n`;
        });
        newItem.extendedProps.output = '';
        newItem.extendedProps.outputPDF = '';
        newItem.extendedProps.outputString = '';
        item.outputs.items
          .filter((output) => !!output)
          .forEach((el) => {
            const [outputConfig] = newItem.extendedProps.actions.items
              .filter((action) => action.assignedOutput.id === el.output.id);
            const hasWowzaConfig = outputConfig && outputConfig.configWowza;
            const autostartTitle = hasWowzaConfig && outputConfig.configWowza.autostart ? outputConfig.configWowza.autostartOffsetMin : 0;
            const autostartColor = hasWowzaConfig && outputConfig.configWowza.autostart ? 'green' : 'red';
            const autostartString = `<i class="bi bly-time ${autostartColor}" title="Offset ${autostartTitle} min"></i>`;
            const autostartPDFString = autostartTitle ? `[Offset ${autostartTitle} min]` : '';
            // console.log('===> ', el, newItem.extendedProps, outputConfig);

            const urlPdf = el.output.url ? `URL: ${el.output.url}` : '';
            newItem.extendedProps.output += `
              <div class="output-${el.output.status}">
                ${el.output.displayName || el.output.name}
                <span class="output-type-tag ${el.output.outputType}">${el.output.outputType}</span>
                <span class="output-type-tag output-status-${el.output.status}">${el.output.status}</span>
                ${hasWowzaConfig ? autostartString : ''}
                <div class="show-ma ${el.output.ottServer}">(${el.output.ottServer} - ${el.output.ottApplication})</div>
              </div>
            `;

            const ott = `[${el.output.ottServer} - ${el.output.ottApplication}]`;
            const ottOverrride = `[OTT Override: ${el.outputOttApplicationOverride}]`;
            newItem.extendedProps.outputPDF += `${el.output.displayName || el.output.name} [${el.output.outputType}]${hasWowzaConfig ? autostartPDFString : ''} ${el.output.ottServer ? ott : ''} ${el.outputOttApplicationOverride ? ottOverrride : ''} ${urlPdf} \r\n`;

            newItem.extendedProps.outputString += `${el.output.displayName || el.output.name} [${el.output.outputType}]${hasWowzaConfig ? autostartPDFString : ''} ${el.output.ottServer ? ott : ''} ${el.outputOttApplicationOverride ? ottOverrride : ''}, `;
            if (el.outputOttApplicationOverride) {
              newItem.extendedProps.output += `<span class="show-ma" >(OTT Override: <strong>${el.outputOttApplicationOverride}</strong>)</span>
              `;
            }
          });

        const hasRelatedEvents = this.eventsWithTheSameOTT.filter((ev) => ev.id === item.id).length > 0;
        if (hasRelatedEvents) newItem.extendedProps.output += '<span class="warning">OVERLAPPING EVENTS WITH THE SAME OUTPUT</span>';
        if (newItem.extendedProps.output === '') newItem.extendedProps.output = 'not set';
        if (newItem.extendedProps.inputName === '') newItem.extendedProps.inputName = 'not set';
        if (newItem.extendedProps.outputPDF === '') newItem.extendedProps.outputPDF = 'not set';
        if (newItem.extendedProps.audioPDF === '') newItem.extendedProps.audioPDF = 'not set';

        newItem.extendedProps.inputPDF = newItem.extendedProps.inputName.replace('<br>', '');
        this.setActiveEvent(newItem);
        this.event = newItem;
    },
  },
};
</script>

<style>
div#agenda-event-preview .time-editor {
  user-select: none;
}

div#agenda-event-preview .time-editor, div#agenda-event-preview .preview-panel-audio-channel-actions .btn-icon:hover, div#agenda-event-preview .content.editable {
  cursor: pointer;
  transition: 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
}



.el-loading-spinner svg {
  margin: 0 auto;
}

#agenda-event-preview {
  user-select: text;
}
#agenda-event-preview .output-DELETED {
  text-decoration: line-through;
}
#agenda-event-preview .transcoder-profile i {
  top: 7px !important;
  margin-right: 4px;
}
#agenda-event-preview .bly-time.active {
  color: #67c23a;
}
#agenda-event-preview .donwling-config-information .label .icon-btn {
  float: right;
  position: relative;
  top: -14px;
}
#agenda-event-preview .donwling-config-information .bly-edit {
  right: 40px !important;
  top: -16px;
}
#agenda-event-preview .donwling-config-information .copy-all {
  top: -10px;
  position: relative;
}
#agenda-event-preview .donwling-config-information .copy-property {
  position: absolute;
  float: right;
  top: 0;
  right: 0px;
}
#agenda-event-preview .donwling-config-information #downlinkInfo div {
  position: relative;
}
#agenda-event-preview .donwling-config-information #downlinkInfo div span {
  display: block;
  position: relative;
}
#agenda-event-preview .donwling-config-information #downlinkInfo div i {
  display: none;
}
#agenda-event-preview .donwling-config-information #downlinkInfo div:hover {
  color: #ff9f31;
}
#agenda-event-preview .donwling-config-information #downlinkInfo div:hover i {
  display: block;
}
#agenda-event-preview .content:focus {
  outline: none;
}
#agenda-event-preview .attachments-upload {
  float: right;
  position: relative;
  top: -15px;
}
#agenda-event-preview .attachment-link {
  margin-top: 4px;
  line-height: 20px;
  cursor: pointer;
}
#agenda-event-preview .attachment-link:hover {
  color: #ff9f31;
}

.disableEditing {
  pointer-events: none;
}

.desktop .SCHEDULEDEFAULT .el-drawer__wrapper {
  z-index: 0 !important;
  max-width: 360px;
  left: auto;
}
.desktop .SCHEDULEDEFAULT .details-panel .el-dialog__wrapper {
  left: calc(100vw - 386px);
  top: 70px;
  z-index: 0;
}
.desktop .event-preview-drawer {
  position: fixed;
  top: 70px;
  right: 10px;
  bottom: 10px;
  height: calc(100vh - 82px);
}
.desktop .event-preview-drawer #el-drawer__title {
  margin-bottom: 0px;
}
.desktop #agenda-event-preview {
  height: calc(100vh - 136px);
}

.mobile .details-panel .el-dialog__wrapper {
  left: 0;
}
.mobile #agenda-event-preview {
  background: transparent;
  position: relative;
  right: 0;
  transition: all 0.4s ease-in;
  bottom: 0;
  top: -30px;
  z-index: 0;
  box-shadow: none !important;
  height: calc(100vh - 54px);
}
.mobile #agenda-event-preview .event-title {
  display: none;
}
.mobile #agenda-event-preview .wrapper {
  height: 100%;
}


div#agenda-event-preview .wrapper {
  height: 100%;
}

div#agenda-event-preview .el-alert {
  margin-bottom: 16px;
  margin-top: -10px;
  padding: 8px;
}
div#agenda-event-preview .close-btn {
  float: right;
  opacity: 0.7;
  display: none;
}
div#agenda-event-preview .two-col {
  display: grid;
  grid-template-columns: 1fr 1fr;
}
div#agenda-event-preview .three-col {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
}
div#agenda-event-preview .event-title {
  font-size: 18px;
  color: #000;
  font-weight: normal;
  margin: 0 0 10px;
}
div#agenda-event-preview.open {
  right: 0;
}
div#agenda-event-preview .el-button--small {
  margin-left: 0px;
  margin-top: 6px;
}
div#agenda-event-preview i.bi,
div#agenda-event-preview .ma-icon {
  position: relative;
  top: 2px;
}
div#agenda-event-preview .label {
  color: #969ba9;
  font-weight: 600;
  font-size: 11px;
  margin-bottom: 2px;
  text-transform: uppercase;
  position: relative;
}
div#agenda-event-preview .label .actions {
  position: absolute;
  right: 0;
  top: -15px;
  color: #000;
  font-size: 14px;
}
div#agenda-event-preview .label.outputs-header {
  margin-bottom: -9px;
}
div#agenda-event-preview .content {
  margin-bottom: 20px;
  line-break: 20px;
  font-size: 14px;
  position: relative;
  color: #000;
}
div#agenda-event-preview .content.editable .bly-edit {
  opacity: 0;
  color: #66718D;
  position: absolute;
  margin-left: 10px;
  right: 0px;
}
div#agenda-event-preview .content.editable:hover {
  text-decoration: dashed underline #0077FF;
}
div#agenda-event-preview .content.editable:hover .bly-edit {
  opacity: 1;
}
div#agenda-event-preview .content.editable:hover .label {
  text-decoration: solid underline white !important;
}
div#agenda-event-preview .content i {
  vertical-align: top;
  position: relative;
  top: 1px;
}
div#agenda-event-preview .content textarea {
  width: 100%;
  border: 0px;
  background: transparent;
}
div#agenda-event-preview .content .input {
  position: relative;
}
div#agenda-event-preview .content .input input {
  width: 100%;
  margin-bottom: 15px;
  line-height: 38px;
  padding: 0 8px;
  color: #66718d;
  font-size: 14px;
  border-radius: 3px;
  border: 1px solid #dde0e6;
  padding-right: 110px;
}
div#agenda-event-preview .content .input .target .status {
  display: inline-block;
  width: 10px;
  height: 10px;
  background: #7f8cad;
  border-radius: 5px;
}
div#agenda-event-preview .content .input .target .status.NotFound {
  background: #fc487f;
}
div#agenda-event-preview .content .input .target .status.Active {
  background: #00d56b;
}
div#agenda-event-preview .content .actions {
  position: absolute;
  top: 0px;
  right: 0px;
}
div#agenda-event-preview .content .actions .icon-btn {
  line-height: 30px;
}
div#agenda-event-preview .content .actions .icon-btn:hover {
  background: #fff;
  color: #000 !important;
}
div#agenda-event-preview .content .actions .icon-btn.bly-play:hover {
  color: #00FF80 !important;
}
div#agenda-event-preview .content .actions .icon-btn.bly-stop:hover {
  color: #ea0d51 !important;
}
div#agenda-event-preview .content .actions .btn {
  margin: 0 0 0 4px;
  width: 32px;
  padding: 0;
  text-align: center;
}
div#agenda-event-preview .el-form-item .el-switch {
  float: right;
}
div#agenda-event-preview .preview-panel-audio-channel {
  border: 1px solid #CDD6EE;
  padding: 5px 8px;
  border-radius: 3px;
  margin-bottom: 4px;
  position: relative;
}
div#agenda-event-preview .preview-panel-audio-channel-number {
  width: 20px;
  margin-bottom: 0px;
  float: left;
}
div#agenda-event-preview .preview-panel-audio-channel-stereo {
  float: right;
  top: -18px;
  right: 2px;
  position: relative;
}
div#agenda-event-preview .preview-panel-audio-channel .audio-is-active {
  border-radius: 10px;
  background: #00FF80;
  width: 10px;
  height: 10px;
  margin-top: 4px;
  margin-left: 0px;
  z-index: 9;
  position: absolute;
  top: 4px;
  left: 23px;
}
div#agenda-event-preview .preview-panel-audio-channel-actions {
  position: absolute;
  right: 10px;
  z-index: 1;
  background: #fff;
  top: 1px;
  bottom: 5px;
  opacity: 0;
  pointer-events: none;
  transition: 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
}
div#agenda-event-preview .preview-panel-audio-channel-actions .btn-icon {
  line-height: 24px;
  width: 24px;
  text-align: center;
  color: #66718D;
  margin-left: 8px;
}
div#agenda-event-preview .preview-panel-audio-channel-actions .btn-icon:hover {
  color: #1A9DFF;
}
div#agenda-event-preview .preview-panel-audio-channel:hover .preview-panel-audio-channel-actions {
  opacity: 1;
  pointer-events: auto;
}
div#agenda-event-preview .preview-panel-audio-channel-name-left {
  position: relative;
  padding-left: 30px;
  font-size: 13px;
}
div#agenda-event-preview .preview-outputs .el-card {
  margin-bottom: 12px;
  padding-bottom: 16px;
}
div#agenda-event-preview .preview-outputs .el-card small {
  color: #66718D;
  font-weight: normal;
}
div#agenda-event-preview .preview-outputs .el-card small.stream-key {
  font-size: 14px;
  word-break: break-all;
  margin-top: 4px;
  display: block;
}
div#agenda-event-preview .preview-outputs .el-card small.stream-key i {
  top: 4px;
}
div#agenda-event-preview .preview-outputs .el-card small.transcoder-profile {
  font-size: 14px;
  word-break: break-all;
  margin-top: 4px;
  display: block;
}
div#agenda-event-preview .preview-outputs .el-card small.transcoder-profile i {
  top: 4px;
}
div#agenda-event-preview .preview-outputs .el-card .actions {
  bottom: 0;
  top: auto;
}
div#agenda-event-preview .time-editor .bi {
  opacity: 0;
  pointer-events: none;
}
div#agenda-event-preview .time-editor:hover .bi {
  opacity: 1;
}
div#agenda-event-preview .time-editor .el-date-editor {
  position: absolute;
  left: 0;
  opacity: 0.01;
  height: 20px;
}
div#agenda-event-preview .time-editor .el-date-editor .el-input__prefix {
  width: 100%;
}
div#agenda-event-preview .time-editor .el-date-editor .el-input__prefix .el-input__icon {
  width: 100%;
}
div#agenda-event-preview .time-editor .el-date-editor input {
  pointer-events: none;
}

.el-card {
  position: relative;
}
.el-card.new-output-card {
  margin-bottom: 10px;
  cursor: pointer;
}
.el-card .el-switch {
  position: absolute;
  right: 12px;
  top: 50%;
  margin-top: -10px;
}
.el-card .el-switch.pointer-diabled {
  pointer-events: none;
}

.tx-report-booking-details {
  border: 1px solid #ddd;
  padding: 16px;
  border-radius: 4px;
}
.tx-report-booking-details .content {
  color: #000;
}
.tx-report-booking-details .label {
  font-weight: 600;
  font-size: 11px;
  margin-bottom: 2px;
  text-transform: uppercase;
  opacity: 0.6;
  margin-top: 16px;
}

.el-alert .el-alert__description {
  margin: 5px 0;
}
.el-alert .el-alert__description el-button {
  position: absolute;
  right: 0;
  top: 9px;
  right: 6px;
}

.theme-mini .details-panel .event-preview-drawer #el-drawer__title .el-tag--mini {
  top: 0;
  position: absolute;
  right: 0;
  font-size: 12px;
  padding: 4px 8px;
  height: auto;
  border-radius: 0px 0px 0px 5px;
  font-weight: 400;
  letter-spacing: 1px;
}
.theme-mini .panel-info-message {
  padding: 40px;
  font-size: 18px;
  text-align: center;
  display: grid;
  height: 100%;
  grid-template-rows: auto;
  align-content: center;
}
.theme-mini .panel-info-message div {
  overflow: hidden !important;
}
.theme-mini .panel-info-message svg {
  display: block;
  margin: 20px auto;
}
.theme-mini .panel-info-message i {
  display: block;
  font-size: 4em;
  margin-bottom: 30px;
}
.theme-mini .el-dropdown-link {
  cursor: pointer;
}

/* Router Output Status Styles for AgendaPreview */
.router-output-status {
  display: inline-flex;
  align-items: center;
  padding: 2px 6px;
  border-radius: 3px;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  margin: 2px 4px 2px 0;
  line-height: 1.2;
  margin-top: -2px;
  height: 18px;
}

.router-output-status.status-active {
  background-color: #10b981;
  color: white;
}

.router-output-status.status-disabled {
  background-color: #6b7280;
  color: white;
}

.router-output-status.status-error {
  background-color: #ef4444;
  color: white;
}

.router-output-status.status-waiting {
  background-color: #f59e0b;
  color: white;
}

.router-output-status.status-inactive {
  background-color: #374151;
  color: white;
}

.router-output-status.status-undefined {
  background-color: #8b5cf6;
  color: white;
}

.router-output-status.status-unknown {
  background-color: #374151;
  color: white;
}

/* Router status indicator dot for AgendaPreview */
.router-status-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 3px;
}

.router-status-dot.status-active {
  background-color: #10b981;
}

.router-status-dot.status-disabled {
  background-color: #6b7280;
}

.router-status-dot.status-error {
  background-color: #ef4444;
}

.router-status-dot.status-inactive {
  background-color: #f59e0b;
}

.router-status-dot.status-waiting {
  background-color: #f59e0b;
}

.router-status-dot.status-undefined {
  background-color: #8b5cf6;
}

.router-status-dot.status-unknown {
  background-color: white;
}

/* Pulse animation for active router status */
@keyframes pulse-router-status {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
  100% {
    opacity: 1;
  }
}

.router-status-dot.status-active,
.router-output-status.status-active {
  animation: pulse-router-status 2s ease-in-out infinite;
}
</style>
